// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostErrors, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponses, AssignAccountsAppAccountsAssignPostData, AssignAccountsAppAccountsAssignPostErrors, AssignAccountsAppAccountsAssignPostResponses, AuthBearerLoginAuthBearerLoginPostData, AuthBearerLoginAuthBearerLoginPostErrors, AuthBearerLoginAuthBearerLoginPostResponses, AuthBearerLogoutAuthBearerLogoutPostData, AuthBearerLogoutAuthBearerLogoutPostErrors, AuthBearerLogoutAuthBearerLogoutPostResponses, AuthCookieLoginAuthLoginPostData, AuthCookieLoginAuthLoginPostErrors, AuthCookieLoginAuthLoginPostResponses, AuthCookieLogoutAuthLogoutPostData, AuthCookieLogoutAuthLogoutPostErrors, AuthCookieLogoutAuthLogoutPostResponses, ChatAuthAppChatAuthGetData, ChatAuthAppChatAuthGetResponses, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetData, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetErrors, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponses, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostErrors, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponses, ClaimLeadsAppScoutClaimPostData, ClaimLeadsAppScoutClaimPostResponses, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostErrors, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponses, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostErrors, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponses, CreateAccountFromCompanyDataAppAccountsQuickCreatePostData, CreateAccountFromCompanyDataAppAccountsQuickCreatePostErrors, CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponses, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostErrors, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponses, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostErrors, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponses, CreateBuyerProfileAppBuyerProfilesPostData, CreateBuyerProfileAppBuyerProfilesPostErrors, CreateBuyerProfileAppBuyerProfilesPostResponses, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostErrors, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponses, CreateMarketResearchReportAppMarketResearchReportsPostData, CreateMarketResearchReportAppMarketResearchReportsPostErrors, CreateMarketResearchReportAppMarketResearchReportsPostResponses, CreateMemberAppOrganizationOrganizationsMembersPostData, CreateMemberAppOrganizationOrganizationsMembersPostErrors, CreateMemberAppOrganizationOrganizationsMembersPostResponses, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostErrors, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponses, CreateNoteAppAccountsNotesAccountIdPostData, CreateNoteAppAccountsNotesAccountIdPostErrors, CreateNoteAppAccountsNotesAccountIdPostResponses, CreateOrganizationSuperuserCreatePostData, CreateOrganizationSuperuserCreatePostErrors, CreateOrganizationSuperuserCreatePostResponses, CreatePersonaAppOrganizationPersonasPostData, CreatePersonaAppOrganizationPersonasPostErrors, CreatePersonaAppOrganizationPersonasPostResponses, CreateProductAppProductsPostData, CreateProductAppProductsPostErrors, CreateProductAppProductsPostResponses, CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData, CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponses, CustomExportDownloadAppAccountsExportCustomExportDownloadPostData, CustomExportDownloadAppAccountsExportCustomExportDownloadPostErrors, CustomExportDownloadAppAccountsExportCustomExportDownloadPostResponses, CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetData, CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponses, CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetData, CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponses, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostErrors, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponses, CustomExportPreviewAppAccountsExportCustomExportPreviewPostData, CustomExportPreviewAppAccountsExportCustomExportPreviewPostErrors, CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponses, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutErrors, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponses, DeleteAccountsAppAccountsDeleteData, DeleteAccountsAppAccountsDeleteErrors, DeleteAccountsAppAccountsDeleteResponses, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteErrors, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponses, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteErrors, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteResponses, DeleteFeedbackData, DeleteFeedbackErrors, DeleteFeedbackResponses, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteErrors, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteResponses, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteErrors, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponses, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteErrors, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponses, DeleteOrdersAppOrdersDeleteData, DeleteOrdersAppOrdersDeleteErrors, DeleteOrdersAppOrdersDeleteResponses, DeletePersonaAppOrganizationPersonasPersonaIdDeleteData, DeletePersonaAppOrganizationPersonasPersonaIdDeleteErrors, DeletePersonaAppOrganizationPersonasPersonaIdDeleteResponses, DeleteProductAppProductsProductIdDeleteData, DeleteProductAppProductsProductIdDeleteErrors, DeleteProductAppProductsProductIdDeleteResponses, DemodaySignupAppDemodaySignupPostData, DemodaySignupAppDemodaySignupPostErrors, DemodaySignupAppDemodaySignupPostResponses, DevLoginDevLoginEmailPostData, DevLoginDevLoginEmailPostErrors, DevLoginDevLoginEmailPostResponses, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostErrors, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponses, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostErrors, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponses, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetData, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetErrors, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostErrors, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostErrors, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponses, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostErrors, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponses, EnrichByLinkedinUrlAppLinkedinEnrichPostData, EnrichByLinkedinUrlAppLinkedinEnrichPostErrors, EnrichByLinkedinUrlAppLinkedinEnrichPostResponses, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostErrors, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponses, ExchangeTokenAppIntegrationsMergeExchangeTokenPostData, ExchangeTokenAppIntegrationsMergeExchangeTokenPostErrors, ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponses, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostErrors, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponses, ExecuteBatchUploadSuperuserBatchUploadsExecutePostData, ExecuteBatchUploadSuperuserBatchUploadsExecutePostErrors, ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponses, ExportAccountsAppAccountsExportExportPostData, ExportAccountsAppAccountsExportExportPostErrors, ExportAccountsAppAccountsExportExportPostResponses, ExportContactsAppAccountsExportContactsPostData, ExportContactsAppAccountsExportContactsPostErrors, ExportContactsAppAccountsExportContactsPostResponses, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostErrors, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponses, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostErrors, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponses, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostErrors, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponses, GenerateEmailAppAccountActionsEmailGenerationPostData, GenerateEmailAppAccountActionsEmailGenerationPostErrors, GenerateEmailAppAccountActionsEmailGenerationPostResponses, GenerateTamReportSuperuserTamReportsPostData, GenerateTamReportSuperuserTamReportsPostErrors, GenerateTamReportSuperuserTamReportsPostResponses, GetAccountContactsAppAccountsContactsAccountIdGetData, GetAccountContactsAppAccountsContactsAccountIdGetErrors, GetAccountContactsAppAccountsContactsAccountIdGetResponses, GetAccountContactsFullAppAccountsContactsAccountIdFullGetData, GetAccountContactsFullAppAccountsContactsAccountIdFullGetErrors, GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponses, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetErrors, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponses, GetAccountDetailsAppAccountsAccountsAccountIdGetData, GetAccountDetailsAppAccountsAccountsAccountIdGetErrors, GetAccountDetailsAppAccountsAccountsAccountIdGetResponses, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostErrors, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponses, GetAccountHistoryAppAccountsHistoryAccountIdGetData, GetAccountHistoryAppAccountsHistoryAccountIdGetErrors, GetAccountHistoryAppAccountsHistoryAccountIdGetResponses, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetData, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetErrors, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponses, GetAccountsHeatMapAppAccountsHeatMapsPostData, GetAccountsHeatMapAppAccountsHeatMapsPostErrors, GetAccountsHeatMapAppAccountsHeatMapsPostResponses, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetData, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetErrors, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponses, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetData, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetErrors, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponses, GetActivityLogAppAccountActionsActivityLogGetData, GetActivityLogAppAccountActionsActivityLogGetErrors, GetActivityLogAppAccountActionsActivityLogGetResponses, GetActivityStatsAppAccountActionsActivityStatsGetData, GetActivityStatsAppAccountActionsActivityStatsGetErrors, GetActivityStatsAppAccountActionsActivityStatsGetResponses, GetActivityTimelineAppAccountActionsActivityTimelineGetData, GetActivityTimelineAppAccountActionsActivityTimelineGetErrors, GetActivityTimelineAppAccountActionsActivityTimelineGetResponses, GetAgentRunAppAgentRunsRunIdGetData, GetAgentRunAppAgentRunsRunIdGetErrors, GetAgentRunAppAgentRunsRunIdGetResponses, GetAllOrganizationsSuperuserOrganizationsGetData, GetAllOrganizationsSuperuserOrganizationsGetResponses, GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetData, GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponses, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetData, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetErrors, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponses, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetData, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetErrors, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponses, GetCompanyInfoAppOrganizationCompanyInfoGetData, GetCompanyInfoAppOrganizationCompanyInfoGetResponses, GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetData, GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponses, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetData, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetErrors, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponses, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetData, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetErrors, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponses, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetData, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetErrors, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponses, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetErrors, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponses, GetCrmUsersAppIntegrationsMergeCrmUsersGetData, GetCrmUsersAppIntegrationsMergeCrmUsersGetResponses, GetDashboardAppScoutDashboardGetData, GetDashboardAppScoutDashboardGetResponses, GetDealEventsAppOrdersDealsDealIdEventsGetData, GetDealEventsAppOrdersDealsDealIdEventsGetErrors, GetDealEventsAppOrdersDealsDealIdEventsGetResponses, GetDebriefHistoryAppDebriefHistoryGetData, GetDebriefHistoryAppDebriefHistoryGetErrors, GetDebriefHistoryAppDebriefHistoryGetResponses, GetDistributorsAppOrganizationOrganizationsDistributorsGetData, GetDistributorsAppOrganizationOrganizationsDistributorsGetResponses, GetEmailPreferencesData, GetEmailPreferencesResponses, GetEnrichmentFreshnessSuperuserFreshnessGetData, GetEnrichmentFreshnessSuperuserFreshnessGetResponses, GetEnrichmentStatusSuperuserEnrichmentStatusGetData, GetEnrichmentStatusSuperuserEnrichmentStatusGetResponses, GetExportEmailsAppAccountsExportEmailsPostData, GetExportEmailsAppAccountsExportEmailsPostErrors, GetExportEmailsAppAccountsExportEmailsPostResponses, GetFeedbackData, GetFeedbackErrors, GetFeedbackResponses, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetData, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetErrors, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponses, GetImpersonationStatusSuperuserImpersonationCurrentGetData, GetImpersonationStatusSuperuserImpersonationCurrentGetResponses, GetInboundAddressAppOrdersInboundAddressGetData, GetInboundAddressAppOrdersInboundAddressGetResponses, GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetData, GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponses, GetIntegrationStatusAppIntegrationsMergeStatusGetData, GetIntegrationStatusAppIntegrationsMergeStatusGetResponses, GetMapPointsAppAccountsAccountsMapPointsPostData, GetMapPointsAppAccountsAccountsMapPointsPostErrors, GetMapPointsAppAccountsAccountsMapPointsPostResponses, GetMarketResearchReportAppMarketResearchReportsReportIdGetData, GetMarketResearchReportAppMarketResearchReportsReportIdGetErrors, GetMarketResearchReportAppMarketResearchReportsReportIdGetResponses, GetMarketResearchReportsAppMarketResearchReportsGetData, GetMarketResearchReportsAppMarketResearchReportsGetResponses, GetNewsfeedAppInboxNewsfeedGetData, GetNewsfeedAppInboxNewsfeedGetErrors, GetNewsfeedAppInboxNewsfeedGetResponses, GetOrderAppOrdersOrderIdGetData, GetOrderAppOrdersOrderIdGetErrors, GetOrderAppOrdersOrderIdGetResponses, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetData, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetErrors, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetResponses, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetErrors, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetResponses, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetData, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetErrors, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponses, GetOrderPreviewAppOrdersOrderIdPreviewGetData, GetOrderPreviewAppOrdersOrderIdPreviewGetErrors, GetOrderPreviewAppOrdersOrderIdPreviewGetResponses, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetErrors, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponses, GetOrganizationInfoAppOrganizationOrganizationsInfoGetData, GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponses, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetErrors, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponses, GetPartnersAppOnboardingPartnersGetData, GetPartnersAppOnboardingPartnersGetResponses, GetPersonasAppOrganizationPersonasGetData, GetPersonasAppOrganizationPersonasGetResponses, GetProductAppProductsProductIdGetData, GetProductAppProductsProductIdGetErrors, GetProductAppProductsProductIdGetResponses, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetData, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetErrors, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponses, GetRecommendationCountAppInboxRecommendationsCountGetData, GetRecommendationCountAppInboxRecommendationsCountGetResponses, GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetData, GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponses, GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetData, GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponses, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetData, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetErrors, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponses, GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetData, GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponses, GetTamReportAppTamReportsReportIdGetData, GetTamReportAppTamReportsReportIdGetErrors, GetTamReportAppTamReportsReportIdGetResponses, GetTamReportsAppTamReportsGetData, GetTamReportsAppTamReportsGetResponses, GetUserSuperuserUsersUserIdGetData, GetUserSuperuserUsersUserIdGetErrors, GetUserSuperuserUsersUserIdGetResponses, GetVectorTileAppAccountsAccountsTilesZxyPbfGetData, GetVectorTileAppAccountsAccountsTilesZxyPbfGetErrors, GetVectorTileAppAccountsAccountsTilesZxyPbfGetResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, HealthDetailedHealthDetailedGetData, HealthDetailedHealthDetailedGetResponses, InboundEmailWebhooksInboundEmailPostData, InboundEmailWebhooksInboundEmailPostResponses, JoinAppDemodayJoinPostData, JoinAppDemodayJoinPostErrors, JoinAppDemodayJoinPostResponses, JoinCompleteAppOnboardingJoinCompletePostData, JoinCompleteAppOnboardingJoinCompletePostErrors, JoinCompleteAppOnboardingJoinCompletePostResponses, JoinInfoAppOnboardingJoinInfoGetData, JoinInfoAppOnboardingJoinInfoGetErrors, JoinInfoAppOnboardingJoinInfoGetResponses, LaunchAgentRunAppAgentRunsLaunchPostData, LaunchAgentRunAppAgentRunsLaunchPostErrors, LaunchAgentRunAppAgentRunsLaunchPostResponses, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostErrors, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostResponses, ListAgentRunsAppAgentRunsGetData, ListAgentRunsAppAgentRunsGetErrors, ListAgentRunsAppAgentRunsGetResponses, ListBuyerProfilesAppBuyerProfilesGetData, ListBuyerProfilesAppBuyerProfilesGetResponses, ListDealsAppOrdersDealsGetData, ListDealsAppOrdersDealsGetErrors, ListDealsAppOrdersDealsGetResponses, ListDemodayOrgsAppDemodayOrgsGetData, ListDemodayOrgsAppDemodayOrgsGetResponses, ListDevUsersDevUsersGetData, ListDevUsersDevUsersGetResponses, ListImpersonationSessionsSuperuserImpersonationSessionsGetData, ListImpersonationSessionsSuperuserImpersonationSessionsGetResponses, ListNotesAppAccountsNotesAccountIdGetData, ListNotesAppAccountsNotesAccountIdGetErrors, ListNotesAppAccountsNotesAccountIdGetResponses, ListOrdersAppOrdersGetData, ListOrdersAppOrdersGetErrors, ListOrdersAppOrdersGetResponses, ListProductsAppProductsGetData, ListProductsAppProductsGetErrors, ListProductsAppProductsGetResponses, ListRecommendationsAppInboxRecommendationsGetData, ListRecommendationsAppInboxRecommendationsGetErrors, ListRecommendationsAppInboxRecommendationsGetResponses, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetData, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetErrors, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponses, LogActivityActionsAppAccountActionsActivityActionsPostData, LogActivityActionsAppAccountActionsActivityActionsPostErrors, LogActivityActionsAppAccountActionsActivityActionsPostResponses, MagicLinkAuthMagicLinkPostData, MagicLinkAuthMagicLinkPostErrors, MagicLinkAuthMagicLinkPostResponses, MagicLinkCallbackAuthMagicLinkCallbackPostData, MagicLinkCallbackAuthMagicLinkCallbackPostErrors, MagicLinkCallbackAuthMagicLinkCallbackPostResponses, MailpitInboundWebhooksMailpitInboundPostData, MailpitInboundWebhooksMailpitInboundPostResponses, MarkReadAppInboxRecommendationsRecommendationIdReadPostData, MarkReadAppInboxRecommendationsRecommendationIdReadPostErrors, MarkReadAppInboxRecommendationsRecommendationIdReadPostResponses, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostErrors, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponses, OnboardingActivateAppOnboardingActivateGetData, OnboardingActivateAppOnboardingActivateGetErrors, OnboardingActivateAppOnboardingActivateGetResponses, OnboardingCompleteAppOnboardingCompletePostData, OnboardingCompleteAppOnboardingCompletePostErrors, OnboardingCompleteAppOnboardingCompletePostResponses, OnboardingExchangeTokenAppOnboardingExchangeTokenPostData, OnboardingExchangeTokenAppOnboardingExchangeTokenPostErrors, OnboardingExchangeTokenAppOnboardingExchangeTokenPostResponses, OrderStatsAppOrdersStatsGetData, OrderStatsAppOrdersStatsGetResponses, ParseFiltersAppAccountsParseFiltersPostData, ParseFiltersAppAccountsParseFiltersPostErrors, ParseFiltersAppAccountsParseFiltersPostResponses, ParseTerritoryAppOnboardingParseTerritoryPostData, ParseTerritoryAppOnboardingParseTerritoryPostErrors, ParseTerritoryAppOnboardingParseTerritoryPostResponses, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostErrors, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponses, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostErrors, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponses, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostErrors, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponses, ParseValidateSuperuserBatchUploadsParseValidatePostData, ParseValidateSuperuserBatchUploadsParseValidatePostErrors, ParseValidateSuperuserBatchUploadsParseValidatePostResponses, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostErrors, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponses, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetData, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetErrors, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponses, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostErrors, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponses, QueryAccountsListAppAccountsAccountsListPostData, QueryAccountsListAppAccountsAccountsListPostErrors, QueryAccountsListAppAccountsAccountsListPostResponses, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostErrors, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponses, QuickTrialCreateSuperuserCreateQuickPostData, QuickTrialCreateSuperuserCreateQuickPostErrors, QuickTrialCreateSuperuserCreateQuickPostResponses, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostErrors, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponses, ReportDataIssueData, ReportDataIssueErrors, ReportDataIssueResponses, ReprocessOrderAppOrdersOrderIdReprocessPostData, ReprocessOrderAppOrdersOrderIdReprocessPostErrors, ReprocessOrderAppOrdersOrderIdReprocessPostResponses, RerunTriageAnalysisSuperuserRerunTriagePostData, RerunTriageAnalysisSuperuserRerunTriagePostErrors, RerunTriageAnalysisSuperuserRerunTriagePostResponses, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostErrors, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponses, ResetForgotPasswordAuthForgotPasswordPostData, ResetForgotPasswordAuthForgotPasswordPostErrors, ResetForgotPasswordAuthForgotPasswordPostResponses, ResetResetPasswordAuthResetPasswordPostData, ResetResetPasswordAuthResetPasswordPostErrors, ResetResetPasswordAuthResetPasswordPostResponses, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostErrors, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponses, RespondToAgentRunAppAgentRunsRunIdRespondPostData, RespondToAgentRunAppAgentRunsRunIdRespondPostErrors, RespondToAgentRunAppAgentRunsRunIdRespondPostResponses, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostErrors, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponses, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostErrors, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponses, RetryOrderAppOrdersOrderIdRetryPostData, RetryOrderAppOrdersOrderIdRetryPostErrors, RetryOrderAppOrdersOrderIdRetryPostResponses, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteErrors, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteResponses, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostErrors, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponses, SaveDebriefAppDebriefSavePostData, SaveDebriefAppDebriefSavePostErrors, SaveDebriefAppDebriefSavePostResponses, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutErrors, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponses, ShareAccountsAppAccountsSharePostData, ShareAccountsAppAccountsSharePostErrors, ShareAccountsAppAccountsSharePostResponses, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostErrors, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponses, StartBackfillInboxSuperuserBackfillInboxPostData, StartBackfillInboxSuperuserBackfillInboxPostErrors, StartBackfillInboxSuperuserBackfillInboxPostResponses, StartDebriefConversationAppDebriefDebriefIdConversationStartPostData, StartDebriefConversationAppDebriefDebriefIdConversationStartPostErrors, StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponses, StartImpersonationSuperuserImpersonationStartPostData, StartImpersonationSuperuserImpersonationStartPostErrors, StartImpersonationSuperuserImpersonationStartPostResponses, StartNewDebriefConversationAppDebriefConversationStartPostData, StartNewDebriefConversationAppDebriefConversationStartPostResponses, StopImpersonationSuperuserImpersonationStopPostData, StopImpersonationSuperuserImpersonationStopPostResponses, StreamAgentRunAppAgentRunsRunIdStreamGetData, StreamAgentRunAppAgentRunsRunIdStreamGetErrors, StreamAgentRunAppAgentRunsRunIdStreamGetResponses, SubmitTurnAppAccountsLeadDiscoveryTurnPostData, SubmitTurnAppAccountsLeadDiscoveryTurnPostErrors, SubmitTurnAppAccountsLeadDiscoveryTurnPostResponses, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostErrors, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponses, SyncMergeAccountsAppIntegrationsMergeSyncPostData, SyncMergeAccountsAppIntegrationsMergeSyncPostErrors, SyncMergeAccountsAppIntegrationsMergeSyncPostResponses, TrackAccountViewAppAccountsAccountsAccountIdViewPostData, TrackAccountViewAppAccountsAccountsAccountIdViewPostErrors, TrackAccountViewAppAccountsAccountsAccountIdViewPostResponses, TranscribeDebriefAppDebriefTranscribePostData, TranscribeDebriefAppDebriefTranscribePostErrors, TranscribeDebriefAppDebriefTranscribePostResponses, TransitionDealStageAppOrdersDealsDealIdStagePostData, TransitionDealStageAppOrdersDealsDealIdStagePostErrors, TransitionDealStageAppOrdersDealsDealIdStagePostResponses, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostErrors, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponses, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostErrors, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponses, UnassignAccountsAppAccountsAssignDeleteData, UnassignAccountsAppAccountsAssignDeleteErrors, UnassignAccountsAppAccountsAssignDeleteResponses, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteErrors, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteResponses, UpdateBuyerProfileAppBuyerProfilesTagIdPatchData, UpdateBuyerProfileAppBuyerProfilesTagIdPatchErrors, UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponses, UpdateCompanyInfoAppOrganizationCompanyInfoPatchData, UpdateCompanyInfoAppOrganizationCompanyInfoPatchErrors, UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponses, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchErrors, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponses, UpdateEmailPreferencesData, UpdateEmailPreferencesErrors, UpdateEmailPreferencesResponses, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutErrors, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponses, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchErrors, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponses, UpdateOrderAppOrdersOrderIdPatchData, UpdateOrderAppOrdersOrderIdPatchErrors, UpdateOrderAppOrdersOrderIdPatchResponses, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchErrors, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponses, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostErrors, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponses, UpdateProductAppProductsProductIdPatchData, UpdateProductAppProductsProductIdPatchErrors, UpdateProductAppProductsProductIdPatchResponses, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutErrors, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponses, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchErrors, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponses, UpdateUserSuperuserUsersUserIdPatchData, UpdateUserSuperuserUsersUserIdPatchErrors, UpdateUserSuperuserUsersUserIdPatchResponses, UsersCurrentUserAuthUsersMeGetData, UsersCurrentUserAuthUsersMeGetErrors, UsersCurrentUserAuthUsersMeGetResponses, UsersDeleteUserAuthUsersIdDeleteData, UsersDeleteUserAuthUsersIdDeleteErrors, UsersDeleteUserAuthUsersIdDeleteResponses, UsersPatchCurrentUserAuthUsersMePatchData, UsersPatchCurrentUserAuthUsersMePatchErrors, UsersPatchCurrentUserAuthUsersMePatchResponses, UsersPatchUserAuthUsersIdPatchData, UsersPatchUserAuthUsersIdPatchErrors, UsersPatchUserAuthUsersIdPatchResponses, UsersUserAuthUsersIdGetData, UsersUserAuthUsersIdGetErrors, UsersUserAuthUsersIdGetResponses, VerifyRequestTokenAuthRequestVerifyTokenPostData, VerifyRequestTokenAuthRequestVerifyTokenPostErrors, VerifyRequestTokenAuthRequestVerifyTokenPostResponses, VerifyVerifyAuthVerifyPostData, VerifyVerifyAuthVerifyPostErrors, VerifyVerifyAuthVerifyPostResponses } from './types.gen';
import { zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostBody, zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostPath, zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponse, zAssignAccountsAppAccountsAssignPostBody, zAssignAccountsAppAccountsAssignPostQuery, zAssignAccountsAppAccountsAssignPostResponse, zAuthBearerLoginAuthBearerLoginPostBody, zAuthBearerLoginAuthBearerLoginPostResponse, zAuthCookieLoginAuthLoginPostBody, zAuthCookieLoginAuthLoginPostResponse, zAuthCookieLogoutAuthLogoutPostResponse, zChatAuthAppChatAuthGetResponse, zCheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetPath, zCheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponse, zCheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostBody, zCheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponse, zClaimLeadsAppScoutClaimPostResponse, zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostBody, zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostPath, zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponse, zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostBody, zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostHeaders, zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostPath, zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponse, zCreateAccountFromCompanyDataAppAccountsQuickCreatePostBody, zCreateAccountFromCompanyDataAppAccountsQuickCreatePostResponse, zCreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostPath, zCreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponse, zCreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostBody, zCreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponse, zCreateBuyerProfileAppBuyerProfilesPostBody, zCreateBuyerProfileAppBuyerProfilesPostResponse, zCreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostBody, zCreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponse, zCreateMarketResearchReportAppMarketResearchReportsPostBody, zCreateMarketResearchReportAppMarketResearchReportsPostResponse, zCreateMemberAppOrganizationOrganizationsMembersPostBody, zCreateMemberAppOrganizationOrganizationsMembersPostQuery, zCreateMemberAppOrganizationOrganizationsMembersPostResponse, zCreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostBody, zCreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponse, zCreateNoteAppAccountsNotesAccountIdPostBody, zCreateNoteAppAccountsNotesAccountIdPostPath, zCreateNoteAppAccountsNotesAccountIdPostResponse, zCreateOrganizationSuperuserCreatePostBody, zCreateOrganizationSuperuserCreatePostResponse, zCreatePersonaAppOrganizationPersonasPostBody, zCreatePersonaAppOrganizationPersonasPostResponse, zCreateProductAppProductsPostBody, zCreateProductAppProductsPostResponse, zCustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponse, zCustomExportDownloadAppAccountsExportCustomExportDownloadPostBody, zCustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponse, zCustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponse, zCustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostBody, zCustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponse, zCustomExportPreviewAppAccountsExportCustomExportPreviewPostBody, zCustomExportPreviewAppAccountsExportCustomExportPreviewPostResponse, zCustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutBody, zCustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponse, zDeleteAccountsAppAccountsDeleteBody, zDeleteAccountsAppAccountsDeleteResponse, zDeleteBuyerProfileAppBuyerProfilesTagIdDeletePath, zDeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponse, zDeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeletePath, zDeleteFeedbackPath, zDeleteMarketResearchReportAppMarketResearchReportsReportIdDeletePath, zDeleteMemberAppOrganizationOrganizationsMembersUserIdDeletePath, zDeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponse, zDeleteNoteAppAccountsNotesAccountIdNoteIdDeletePath, zDeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponse, zDeleteOrdersAppOrdersDeleteBody, zDeleteOrdersAppOrdersDeleteResponse, zDeletePersonaAppOrganizationPersonasPersonaIdDeletePath, zDeleteProductAppProductsProductIdDeletePath, zDeleteProductAppProductsProductIdDeleteResponse, zDemodaySignupAppDemodaySignupPostBody, zDemodaySignupAppDemodaySignupPostResponse, zDevLoginDevLoginEmailPostPath, zDisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostPath, zDisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponse, zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostBody, zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostPath, zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponse, zDownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetPath, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostBody, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostPath, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponse, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostBody, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostPath, zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponse, zEndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostPath, zEndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponse, zEnrichByLinkedinUrlAppLinkedinEnrichPostBody, zEnrichByLinkedinUrlAppLinkedinEnrichPostResponse, zEnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostPath, zEnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponse, zExchangeTokenAppIntegrationsMergeExchangeTokenPostBody, zExchangeTokenAppIntegrationsMergeExchangeTokenPostResponse, zExecuteBatchUploadAppAccountsBatchUploadsExecutePostBody, zExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponse, zExecuteBatchUploadSuperuserBatchUploadsExecutePostBody, zExecuteBatchUploadSuperuserBatchUploadsExecutePostResponse, zExportAccountsAppAccountsExportExportPostBody, zExportContactsAppAccountsExportContactsPostBody, zExportRenewalReportAppAccountActionsActivityRenewalReportExportPostBody, zExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponse, zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostPath, zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostQuery, zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponse, zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostBody, zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostPath, zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponse, zGenerateEmailAppAccountActionsEmailGenerationPostBody, zGenerateEmailAppAccountActionsEmailGenerationPostResponse, zGenerateTamReportSuperuserTamReportsPostBody, zGenerateTamReportSuperuserTamReportsPostResponse, zGetAccountContactsAppAccountsContactsAccountIdGetPath, zGetAccountContactsAppAccountsContactsAccountIdGetQuery, zGetAccountContactsAppAccountsContactsAccountIdGetResponse, zGetAccountContactsFullAppAccountsContactsAccountIdFullGetPath, zGetAccountContactsFullAppAccountsContactsAccountIdFullGetQuery, zGetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse, zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetPath, zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetQuery, zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse, zGetAccountDetailsAppAccountsAccountsAccountIdGetPath, zGetAccountDetailsAppAccountsAccountsAccountIdGetResponse, zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostBody, zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostPath, zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponse, zGetAccountHistoryAppAccountsHistoryAccountIdGetPath, zGetAccountHistoryAppAccountsHistoryAccountIdGetQuery, zGetAccountHistoryAppAccountsHistoryAccountIdGetResponse, zGetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetPath, zGetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponse, zGetAccountsHeatMapAppAccountsHeatMapsPostBody, zGetAccountsHeatMapAppAccountsHeatMapsPostResponse, zGetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetQuery, zGetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponse, zGetActivityLeaderboardAppAccountActionsActivityLeaderboardGetQuery, zGetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponse, zGetActivityLogAppAccountActionsActivityLogGetQuery, zGetActivityLogAppAccountActionsActivityLogGetResponse, zGetActivityStatsAppAccountActionsActivityStatsGetQuery, zGetActivityStatsAppAccountActionsActivityStatsGetResponse, zGetActivityTimelineAppAccountActionsActivityTimelineGetQuery, zGetActivityTimelineAppAccountActionsActivityTimelineGetResponse, zGetAgentRunAppAgentRunsRunIdGetPath, zGetAgentRunAppAgentRunsRunIdGetResponse, zGetAllOrganizationsSuperuserOrganizationsGetResponse, zGetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponse, zGetBackfillInboxStatusSuperuserBackfillInboxStatusGetQuery, zGetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponse, zGetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetPath, zGetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponse, zGetCompanyInfoAppOrganizationCompanyInfoGetResponse, zGetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponse, zGetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetPath, zGetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponse, zGetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetPath, zGetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponse, zGetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetPath, zGetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponse, zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetPath, zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetQuery, zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse, zGetCrmUsersAppIntegrationsMergeCrmUsersGetResponse, zGetDashboardAppScoutDashboardGetResponse, zGetDealEventsAppOrdersDealsDealIdEventsGetPath, zGetDealEventsAppOrdersDealsDealIdEventsGetResponse, zGetDebriefHistoryAppDebriefHistoryGetQuery, zGetDebriefHistoryAppDebriefHistoryGetResponse, zGetDistributorsAppOrganizationOrganizationsDistributorsGetResponse, zGetEmailPreferencesResponse, zGetEnrichmentFreshnessSuperuserFreshnessGetResponse, zGetEnrichmentStatusSuperuserEnrichmentStatusGetResponse, zGetExportEmailsAppAccountsExportEmailsPostBody, zGetExportEmailsAppAccountsExportEmailsPostResponse, zGetFeedbackPath, zGetFeedbackResponse2, zGetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetPath, zGetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponse, zGetImpersonationStatusSuperuserImpersonationCurrentGetResponse, zGetInboundAddressAppOrdersInboundAddressGetResponse, zGetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponse, zGetIntegrationStatusAppIntegrationsMergeStatusGetResponse, zGetMapPointsAppAccountsAccountsMapPointsPostBody, zGetMapPointsAppAccountsAccountsMapPointsPostResponse, zGetMarketResearchReportAppMarketResearchReportsReportIdGetPath, zGetMarketResearchReportAppMarketResearchReportsReportIdGetResponse, zGetMarketResearchReportsAppMarketResearchReportsGetResponse, zGetNewsfeedAppInboxNewsfeedGetQuery, zGetNewsfeedAppInboxNewsfeedGetResponse, zGetOrderAppOrdersOrderIdGetPath, zGetOrderAppOrdersOrderIdGetResponse, zGetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetPath, zGetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetPath, zGetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetPath, zGetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponse, zGetOrderPreviewAppOrdersOrderIdPreviewGetPath, zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetPath, zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetQuery, zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse, zGetOrganizationInfoAppOrganizationOrganizationsInfoGetResponse, zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetPath, zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetQuery, zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse, zGetPartnersAppOnboardingPartnersGetResponse, zGetPersonasAppOrganizationPersonasGetResponse, zGetProductAppProductsProductIdGetPath, zGetProductAppProductsProductIdGetResponse, zGetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetPath, zGetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponse, zGetRecommendationCountAppInboxRecommendationsCountGetResponse, zGetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponse, zGetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponse, zGetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetPath, zGetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponse, zGetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponse, zGetTamReportAppTamReportsReportIdGetPath, zGetTamReportAppTamReportsReportIdGetResponse, zGetTamReportsAppTamReportsGetResponse, zGetUserSuperuserUsersUserIdGetPath, zGetUserSuperuserUsersUserIdGetResponse, zGetVectorTileAppAccountsAccountsTilesZxyPbfGetPath, zGetVectorTileAppAccountsAccountsTilesZxyPbfGetQuery, zHealthCheckHealthGetResponse, zHealthDetailedHealthDetailedGetResponse, zInboundEmailWebhooksInboundEmailPostResponse, zJoinAppDemodayJoinPostBody, zJoinAppDemodayJoinPostResponse, zJoinCompleteAppOnboardingJoinCompletePostBody, zJoinInfoAppOnboardingJoinInfoGetQuery, zJoinInfoAppOnboardingJoinInfoGetResponse, zLaunchAgentRunAppAgentRunsLaunchPostBody, zLaunchAgentRunAppAgentRunsLaunchPostResponse, zLeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostBody, zLeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostPath, zListAgentRunsAppAgentRunsGetQuery, zListAgentRunsAppAgentRunsGetResponse, zListBuyerProfilesAppBuyerProfilesGetResponse, zListDealsAppOrdersDealsGetQuery, zListDealsAppOrdersDealsGetResponse, zListDemodayOrgsAppDemodayOrgsGetResponse, zListDevUsersDevUsersGetResponse, zListImpersonationSessionsSuperuserImpersonationSessionsGetResponse, zListNotesAppAccountsNotesAccountIdGetPath, zListNotesAppAccountsNotesAccountIdGetResponse, zListOrdersAppOrdersGetQuery, zListOrdersAppOrdersGetResponse, zListProductsAppProductsGetQuery, zListProductsAppProductsGetResponse, zListRecommendationsAppInboxRecommendationsGetQuery, zListRecommendationsAppInboxRecommendationsGetResponse, zListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetPath, zListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponse, zLogActivityActionsAppAccountActionsActivityActionsPostBody, zLogActivityActionsAppAccountActionsActivityActionsPostResponse, zMagicLinkAuthMagicLinkPostBody, zMagicLinkCallbackAuthMagicLinkCallbackPostBody, zMailpitInboundWebhooksMailpitInboundPostResponse, zMarkReadAppInboxRecommendationsRecommendationIdReadPostPath, zMarkReadAppInboxRecommendationsRecommendationIdReadPostResponse, zMarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostPath, zMarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponse, zOnboardingActivateAppOnboardingActivateGetQuery, zOnboardingCompleteAppOnboardingCompletePostBody, zOnboardingCompleteAppOnboardingCompletePostResponse, zOnboardingExchangeTokenAppOnboardingExchangeTokenPostQuery, zOrderStatsAppOrdersStatsGetResponse, zParseFiltersAppAccountsParseFiltersPostBody, zParseFiltersAppAccountsParseFiltersPostResponse, zParseTerritoryAppOnboardingParseTerritoryPostBody, zParseTerritoryAppOnboardingParseTerritoryPostResponse, zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostBody, zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostQuery, zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponse, zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostBody, zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostQuery, zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponse, zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostBody, zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostQuery, zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponse, zParseValidateSuperuserBatchUploadsParseValidatePostBody, zParseValidateSuperuserBatchUploadsParseValidatePostResponse, zPartnerInviteCreateAppOnboardingPartnerInviteCreatePostBody, zPartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponse, zPartnerInviteInfoAppOnboardingPartnerInviteInfoGetQuery, zPartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponse, zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostBody, zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostPath, zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponse, zQueryAccountsListAppAccountsAccountsListPostBody, zQueryAccountsListAppAccountsAccountsListPostQuery, zQueryAccountsListAppAccountsAccountsListPostResponse, zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostBody, zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostQuery, zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponse, zQuickTrialCreateSuperuserCreateQuickPostBody, zQuickTrialCreateSuperuserCreateQuickPostResponse, zRegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostPath, zRegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponse, zReportDataIssueBody, zReportDataIssuePath, zReportDataIssueResponse2, zReprocessOrderAppOrdersOrderIdReprocessPostPath, zReprocessOrderAppOrdersOrderIdReprocessPostResponse, zRerunTriageAnalysisSuperuserRerunTriagePostQuery, zRerunTriageAnalysisSuperuserRerunTriagePostResponse, zResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostPath, zResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponse, zResetForgotPasswordAuthForgotPasswordPostBody, zResetResetPasswordAuthResetPasswordPostBody, zResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostPath, zResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponse, zRespondToAgentRunAppAgentRunsRunIdRespondPostBody, zRespondToAgentRunAppAgentRunsRunIdRespondPostPath, zRespondToAgentRunAppAgentRunsRunIdRespondPostResponse, zRetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostPath, zRetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponse, zRetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostPath, zRetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponse, zRetryOrderAppOrdersOrderIdRetryPostPath, zRetryOrderAppOrdersOrderIdRetryPostResponse, zRevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeletePath, zRollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostPath, zRollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponse, zSaveDebriefAppDebriefSavePostBody, zSaveDebriefAppDebriefSavePostResponse, zSetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutPath, zSetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponse, zShareAccountsAppAccountsSharePostBody, zShareAccountsAppAccountsSharePostResponse, zShareAccountViaEmailAppAccountsShareAccountIdEmailPostBody, zShareAccountViaEmailAppAccountsShareAccountIdEmailPostPath, zShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponse, zStartBackfillInboxSuperuserBackfillInboxPostQuery, zStartBackfillInboxSuperuserBackfillInboxPostResponse, zStartDebriefConversationAppDebriefDebriefIdConversationStartPostPath, zStartDebriefConversationAppDebriefDebriefIdConversationStartPostResponse, zStartImpersonationSuperuserImpersonationStartPostBody, zStartNewDebriefConversationAppDebriefConversationStartPostResponse, zStreamAgentRunAppAgentRunsRunIdStreamGetPath, zSubmitTurnAppAccountsLeadDiscoveryTurnPostBody, zSubmitTurnAppAccountsLeadDiscoveryTurnPostResponse, zSyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostPath, zSyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponse, zSyncMergeAccountsAppIntegrationsMergeSyncPostBody, zSyncMergeAccountsAppIntegrationsMergeSyncPostResponse, zTrackAccountViewAppAccountsAccountsAccountIdViewPostPath, zTranscribeDebriefAppDebriefTranscribePostBody, zTranscribeDebriefAppDebriefTranscribePostResponse, zTransitionDealStageAppOrdersDealsDealIdStagePostBody, zTransitionDealStageAppOrdersDealsDealIdStagePostPath, zTransitionDealStageAppOrdersDealsDealIdStagePostResponse, zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostBody, zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostPath, zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponse, zTriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostPath, zTriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponse, zUnassignAccountsAppAccountsAssignDeleteBody, zUnassignAccountsAppAccountsAssignDeleteResponse, zUnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeletePath, zUpdateBuyerProfileAppBuyerProfilesTagIdPatchBody, zUpdateBuyerProfileAppBuyerProfilesTagIdPatchPath, zUpdateBuyerProfileAppBuyerProfilesTagIdPatchResponse, zUpdateCompanyInfoAppOrganizationCompanyInfoPatchBody, zUpdateCompanyInfoAppOrganizationCompanyInfoPatchResponse, zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchBody, zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchPath, zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponse, zUpdateEmailPreferencesBody, zUpdateEmailPreferencesResponse, zUpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutBody, zUpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponse, zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchBody, zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchPath, zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponse, zUpdateOrderAppOrdersOrderIdPatchBody, zUpdateOrderAppOrdersOrderIdPatchPath, zUpdateOrderAppOrdersOrderIdPatchResponse, zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchBody, zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchPath, zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponse, zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostBody, zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostPath, zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponse, zUpdateProductAppProductsProductIdPatchBody, zUpdateProductAppProductsProductIdPatchPath, zUpdateProductAppProductsProductIdPatchResponse, zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutBody, zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutPath, zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponse, zUpdateTagAssociationsAppBuyerProfilesAssociationsPatchBody, zUpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponse, zUpdateUserSuperuserUsersUserIdPatchBody, zUpdateUserSuperuserUsersUserIdPatchPath, zUpdateUserSuperuserUsersUserIdPatchResponse, zUsersCurrentUserAuthUsersMeGetResponse, zUsersDeleteUserAuthUsersIdDeletePath, zUsersDeleteUserAuthUsersIdDeleteResponse, zUsersPatchCurrentUserAuthUsersMePatchBody, zUsersPatchCurrentUserAuthUsersMePatchResponse, zUsersPatchUserAuthUsersIdPatchBody, zUsersPatchUserAuthUsersIdPatchPath, zUsersPatchUserAuthUsersIdPatchResponse, zUsersUserAuthUsersIdGetPath, zUsersUserAuthUsersIdGetResponse, zVerifyRequestTokenAuthRequestVerifyTokenPostBody, zVerifyVerifyAuthVerifyPostBody, zVerifyVerifyAuthVerifyPostResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Query Accounts List
 *
 * Query accounts using Postgres full-text search.
 *
 * Testing note: Integration tests can only verify request/response shape since we
 * mock the search service at the service level. The actual filtering, visibility, and pagination
 * logic lives in query_builder.py and should be unit tested there.
 *
 * Returns:
 * Page[AccountListItem] instance.
 */
export const queryAccountsListAppAccountsAccountsListPost = <ThrowOnError extends boolean = false>(options: Options<QueryAccountsListAppAccountsAccountsListPostData, ThrowOnError>): RequestResult<QueryAccountsListAppAccountsAccountsListPostResponses, QueryAccountsListAppAccountsAccountsListPostErrors, ThrowOnError> => (options.client ?? client).post<QueryAccountsListAppAccountsAccountsListPostResponses, QueryAccountsListAppAccountsAccountsListPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zQueryAccountsListAppAccountsAccountsListPostBody,
        path: z.never().optional(),
        query: zQueryAccountsListAppAccountsAccountsListPostQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQueryAccountsListAppAccountsAccountsListPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query Accounts List Grouped
 *
 * Query accounts grouped by website domain with aggregated stats.
 *
 * Returns domain groups paginated by group count, sorted by the requested
 * sort column applied to each group's aggregate (default: best fit score).
 * Each group includes: domain, logo, account count, best/avg fit score,
 * participant count, and location list.
 *
 * Returns:
 * GroupedAccountsPage with groups and pagination metadata.
 */
export const queryAccountsListGroupedAppAccountsAccountsListGroupedPost = <ThrowOnError extends boolean = false>(options: Options<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData, ThrowOnError>): RequestResult<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponses, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostErrors, ThrowOnError> => (options.client ?? client).post<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponses, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostBody,
        path: z.never().optional(),
        query: zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/list/grouped',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query Accounts By Domain
 *
 * Fetch all accounts for a specific website domain.
 *
 * Used when expanding a group row in the grouped accounts view.
 * Respects the same filters as the grouped list, returning only
 * matching accounts within the domain.
 *
 * Returns:
 * List of AccountListItem for the domain.
 */
export const queryAccountsByDomainAppAccountsAccountsListDomainDomainPost = <ThrowOnError extends boolean = false>(options: Options<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData, ThrowOnError>): RequestResult<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponses, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostErrors, ThrowOnError> => (options.client ?? client).post<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponses, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostBody,
        path: zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/list/domain/{domain}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Account Details
 *
 * Get comprehensive account details with optional enrichment data.
 *
 * This endpoint:
 * 1. Retrieves complete account and company information
 * 2. Uses SQLAlchemy for efficient data fetching
 * 3. Enforces organization-level access control
 *
 * Returns:
 * AccountDetailsResponse instance.
 *
 * Raises:
 * HTTPException: If account not found (404).
 */
export const getAccountDetailsAppAccountsAccountsAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountDetailsAppAccountsAccountsAccountIdGetData, ThrowOnError>): RequestResult<GetAccountDetailsAppAccountsAccountsAccountIdGetResponses, GetAccountDetailsAppAccountsAccountsAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountDetailsAppAccountsAccountsAccountIdGetResponses, GetAccountDetailsAppAccountsAccountsAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountDetailsAppAccountsAccountsAccountIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountDetailsAppAccountsAccountsAccountIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}',
    ...options
});

/**
 * Get Map Points
 *
 * Get map points for accounts as GeoJSON FeatureCollection.
 *
 * Returns lightweight point data for the accounts visible in the requested
 * viewport. Only includes accounts with coordinates. Shares its visibility
 * and filter definition with the vector tile endpoint so the pins on the map
 * and the accounts in the list can never disagree (ENG-3632).
 *
 * Returns:
 * MapPointsResponse with GeoJSON features.
 */
export const getMapPointsAppAccountsAccountsMapPointsPost = <ThrowOnError extends boolean = false>(options: Options<GetMapPointsAppAccountsAccountsMapPointsPostData, ThrowOnError>): RequestResult<GetMapPointsAppAccountsAccountsMapPointsPostResponses, GetMapPointsAppAccountsAccountsMapPointsPostErrors, ThrowOnError> => (options.client ?? client).post<GetMapPointsAppAccountsAccountsMapPointsPostResponses, GetMapPointsAppAccountsAccountsMapPointsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGetMapPointsAppAccountsAccountsMapPointsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMapPointsAppAccountsAccountsMapPointsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/map-points',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Other Locations
 *
 * Get paginated other locations for an account.
 *
 * Returns:
 * OtherLocationsResponse with paginated locations and total count.
 */
export const getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet = <ThrowOnError extends boolean = false>(options: Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData, ThrowOnError>): RequestResult<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponses, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetErrors, ThrowOnError> => (options.client ?? client).get<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponses, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetPath,
        query: zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/other-locations',
    ...options
});

/**
 * Get Sibling Locations
 *
 * Get map points for sibling locations (same domain OR same explorium_id).
 *
 * Finds all accounts that share the same website_domain OR belong to companies
 * with the same explorium_business_id as this account's company.
 *
 * Returns:
 * MapPointsResponse with GeoJSON features.
 *
 * Raises:
 * HTTPException: If account not found (404) or forbidden (403).
 */
export const getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGet = <ThrowOnError extends boolean = false>(options: Options<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetData, ThrowOnError>): RequestResult<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponses, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetErrors, ThrowOnError> => (options.client ?? client).get<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponses, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/sibling-locations',
    ...options
});

/**
 * Get Crm Contacts
 *
 * Get CRM contacts for an account.
 *
 * Returns paginated CRM contacts linked via the account's CRM account.
 *
 * Returns:
 * Page[CrmContactDetails] with contacts from the linked CRM account.
 *
 * Raises:
 * HTTPException: If not authorized (403).
 */
export const getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet = <ThrowOnError extends boolean = false>(options: Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData, ThrowOnError>): RequestResult<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponses, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetErrors, ThrowOnError> => (options.client ?? client).get<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponses, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetPath,
        query: zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/crm-contacts',
    ...options
});

/**
 * Get Crm Accounts
 *
 * Get linked CRM accounts for the View in CRM dialog.
 *
 * Finds all CrmAccounts in the same org + integration as the account's
 * linked CRM account, so the user can deep-link into the CRM.
 *
 * Returns:
 * CrmAccountsResponse with locations and CRM integration info.
 *
 * Raises:
 * HTTPException: If not authorized (403) or account not found (404).
 */
export const getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGet = <ThrowOnError extends boolean = false>(options: Options<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetData, ThrowOnError>): RequestResult<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponses, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetErrors, ThrowOnError> => (options.client ?? client).get<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponses, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/crm-accounts',
    ...options
});

/**
 * Unassign Accounts
 *
 * Remove specific users from account assignments.
 *
 * Supports two modes:
 * 1. Remove from specific accounts by providing accountIds
 * 2. Bulk remove by providing filters (removes from all accounts matching filters)
 *
 * Returns:
 * AssignAccountsResponse with count of removed assignments.
 *
 * Raises:
 * HTTPException: If permission denied (400).
 */
export const unassignAccountsAppAccountsAssignDelete = <ThrowOnError extends boolean = false>(options: Options<UnassignAccountsAppAccountsAssignDeleteData, ThrowOnError>): RequestResult<UnassignAccountsAppAccountsAssignDeleteResponses, UnassignAccountsAppAccountsAssignDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UnassignAccountsAppAccountsAssignDeleteResponses, UnassignAccountsAppAccountsAssignDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUnassignAccountsAppAccountsAssignDeleteBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUnassignAccountsAppAccountsAssignDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/assign/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign Accounts
 *
 * Assign accounts to one or more users (deal participants).
 *
 * Supports two modes:
 * 1. Assign specific accounts by providing accountIds
 * 2. Bulk assign by providing filters (assigns all accounts matching filters)
 *
 * Pass either target_user_id (single) or target_user_ids (multi).
 * When assigning to a user in a distributor organization, set auto_share=True
 * to automatically share unshared accounts with that org before assignment.
 *
 * Returns:
 * AssignAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If an error occurs during assignment (400) or target user not found (404).
 */
export const assignAccountsAppAccountsAssignPost = <ThrowOnError extends boolean = false>(options: Options<AssignAccountsAppAccountsAssignPostData, ThrowOnError>): RequestResult<AssignAccountsAppAccountsAssignPostResponses, AssignAccountsAppAccountsAssignPostErrors, ThrowOnError> => (options.client ?? client).post<AssignAccountsAppAccountsAssignPostResponses, AssignAccountsAppAccountsAssignPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zAssignAccountsAppAccountsAssignPostBody,
        path: z.never().optional(),
        query: zAssignAccountsAppAccountsAssignPostQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAssignAccountsAppAccountsAssignPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/assign/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Account History
 *
 * Get account history including company events and account actions.
 *
 * This endpoint:
 * 1. Retrieves account with company and business_id in one query
 * 2. Fetches company events and account actions with pagination
 * 3. Uses SQLAlchemy for efficient batched queries
 * 4. Enforces organization-level access control
 *
 * Args:
 * account_id: The ID of the account
 * db: The database session
 * current_user: The current user
 * permissions_service: The permissions service for access control
 * events_limit: Max events to return (1-500, default 100)
 * actions_limit: Max actions to return (1-500, default 100)
 *
 * Returns:
 * AccountHistoryResponse with company events and account actions
 *
 * Raises:
 * HTTPException: If account not found or access denied.
 */
export const getAccountHistoryAppAccountsHistoryAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountHistoryAppAccountsHistoryAccountIdGetData, ThrowOnError>): RequestResult<GetAccountHistoryAppAccountsHistoryAccountIdGetResponses, GetAccountHistoryAppAccountsHistoryAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountHistoryAppAccountsHistoryAccountIdGetResponses, GetAccountHistoryAppAccountsHistoryAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountHistoryAppAccountsHistoryAccountIdGetPath,
        query: zGetAccountHistoryAppAccountsHistoryAccountIdGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountHistoryAppAccountsHistoryAccountIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/history/{account_id}',
    ...options
});

/**
 * Parse Validate File
 *
 * Parse and validate a CSV or Excel file upload.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateFileAppAccountsBatchUploadsParseValidateFilePost = <ThrowOnError extends boolean = false>(options: Options<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData, ThrowOnError>): RequestResult<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponses, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostErrors, ThrowOnError> => (options.client ?? client).post<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponses, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostBody,
        path: z.never().optional(),
        query: zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/batch-uploads/parse-validate/file',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Parse Validate Csv Text
 *
 * Parse and validate pasted CSV text.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPost = <ThrowOnError extends boolean = false>(options: Options<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData, ThrowOnError>): RequestResult<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponses, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostErrors, ThrowOnError> => (options.client ?? client).post<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponses, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostBody,
        path: z.never().optional(),
        query: zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/batch-uploads/parse-validate/csv-text',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Parse Validate Json
 *
 * Parse and validate JSON company data from form entry.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateJsonAppAccountsBatchUploadsParseValidateJsonPost = <ThrowOnError extends boolean = false>(options: Options<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData, ThrowOnError>): RequestResult<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponses, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostErrors, ThrowOnError> => (options.client ?? client).post<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponses, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostBody,
        path: z.never().optional(),
        query: zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/batch-uploads/parse-validate/json',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute Batch Upload
 *
 * Execute the batch upload by creating batch upload, companies and accounts.
 *
 * This is the second step after parse-validate.
 * Processes companies in chunks to avoid large transactions.
 *
 * Args:
 * request: ExecuteRequest containing:
 * - new_leads: List of new leads from parse-validate
 * - matches_with_existing_companies: List of matches with existing companies from parse-validate
 * - duplicate_with_existing_accounts: List of duplicates with existing accounts from parse-validate
 * - tags: Optional list of tag assignments with:
 * - company_index: Index in companies array (row_index in first three arguments)
 * - tag_id: Buyer profile ID to assign
 * - batch_upload_data: Metadata for batch upload record
 * - validation_token: Opaque token returned by parse-validate for this payload
 * session: AsyncSession for transactional operations
 * current_user: Authenticated user from JWT token (must match context.user_id)
 * permissions_service: Permission service for authorization checks
 * temporal: Temporal client for starting enrichment workflows
 * redis: Stores short-lived validation tokens from parse-validate
 *
 * Returns:
 * ExecuteResponse with:
 * - stats: Processing statistics:
 * - accounts_processed: Total accounts created
 * - new_accounts: Newly created accounts
 * - new_companies_created: Companies added to database
 * - existing_companies_found: Companies already in database
 * - companies_with_errors: Invalid companies skipped
 * - accounts: List of created account records with:
 * - id: Account UUID
 * - account_name: Name of the account
 * - company_id: Associated company UUID
 * - tag_assignment: If tags provided, contains:
 * - assigned: Number of tag associations created
 * - accounts: Number of accounts tagged
 * - tags: Number of unique tags used
 * - message: Human-readable success message
 *
 * Raises:
 * HTTPException: If permission denied (403), organization not found, or validation token invalid.
 */
export const executeBatchUploadAppAccountsBatchUploadsExecutePost = <ThrowOnError extends boolean = false>(options: Options<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData, ThrowOnError>): RequestResult<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponses, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostErrors, ThrowOnError> => (options.client ?? client).post<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponses, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExecuteBatchUploadAppAccountsBatchUploadsExecutePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/batch-uploads/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Account From Company Data
 *
 * Create an account from company data (name/website/address).
 *
 * This endpoint:
 * 1. Matches to existing company by (domain, name, address) or creates new
 * 2. Creates an account linked to that company (or returns existing)
 * 3. All operations happen atomically in a single database transaction
 *
 * Returns:
 * tuple[AccountModel, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found.
 */
export const createAccountFromCompanyDataAppAccountsQuickCreatePost = <ThrowOnError extends boolean = false>(options: Options<CreateAccountFromCompanyDataAppAccountsQuickCreatePostData, ThrowOnError>): RequestResult<CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponses, CreateAccountFromCompanyDataAppAccountsQuickCreatePostErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponses, CreateAccountFromCompanyDataAppAccountsQuickCreatePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateAccountFromCompanyDataAppAccountsQuickCreatePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateAccountFromCompanyDataAppAccountsQuickCreatePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/quick-create/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Account From Company Id
 *
 * Create an account from an existing company ID.
 *
 * This endpoint:
 * 1. Verifies the company exists
 * 2. Checks if account already exists for this company in the org
 * 3. Creates account if needed, or returns existing
 * 4. Triggers enrichment workflow
 *
 * Returns:
 * tuple[AccountModel, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found or company not found.
 */
export const createAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPost = <ThrowOnError extends boolean = false>(options: Options<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData, ThrowOnError>): RequestResult<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponses, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponses, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/quick-create/from-company/{company_id}',
    ...options
});

/**
 * Create Account From Supplier
 *
 * Create an account from supplier lookup data.
 *
 * This endpoint mirrors the company-data quick-create flow but records
 * the addition as a supplier add (LeadSource.SUPPLIERS) instead of a
 * competitor add, and tracks which account's supplier lookup triggered it.
 *
 * Returns:
 * tuple[AccountModel | None, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found.
 */
export const createAccountFromSupplierAppAccountsQuickCreateFromSupplierPost = <ThrowOnError extends boolean = false>(options: Options<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData, ThrowOnError>): RequestResult<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponses, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponses, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/quick-create/from-supplier',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Turn
 *
 * Submit a user message to a conversation (existing or new).
 *
 * Returns once Temporal has durably accepted the message — typically
 * within a few hundred ms. The browser then polls
 * ``GET /conversations/{id}/state`` for the agent's reply.
 *
 * Returns:
 * :class:`TurnAcceptedResponse` with the conversation id (newly
 * allocated for fresh conversations, echoed back for refinements).
 *
 * Raises:
 * HTTPException: 400 if no organization or empty ``userMessage``;
 * 403 if the caller lacks ``can_import_accounts`` or the
 * ``conversationId`` doesn't belong to the caller's org;
 * 404 if a supplied ``conversationId`` no longer exists;
 * 409 if the validator rejected the update (conversation
 * ended or too many pending turns); 503 on transient Temporal update
 * RPC failures; 500 on other Temporal failures or uuid4 collision.
 */
export const submitTurnAppAccountsLeadDiscoveryTurnPost = <ThrowOnError extends boolean = false>(options: Options<SubmitTurnAppAccountsLeadDiscoveryTurnPostData, ThrowOnError>): RequestResult<SubmitTurnAppAccountsLeadDiscoveryTurnPostResponses, SubmitTurnAppAccountsLeadDiscoveryTurnPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitTurnAppAccountsLeadDiscoveryTurnPostResponses, SubmitTurnAppAccountsLeadDiscoveryTurnPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zSubmitTurnAppAccountsLeadDiscoveryTurnPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSubmitTurnAppAccountsLeadDiscoveryTurnPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/lead-discovery/turn',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Conversation State
 *
 * Return the current transcript, payload, and processing flag.
 *
 * The browser polls this endpoint on a smart interval (1 s while a turn
 * is in flight, 10 s while idle) and stops polling once ``ended`` is true.
 *
 * Returns:
 * Current :class:`ChatState` snapshot from the workflow's
 * ``get_chat_state`` query.
 *
 * Raises:
 * HTTPException: 400 if no organization; 403 if the caller lacks
 * ``can_import_accounts`` or the ``conversationId`` doesn't
 * belong to the caller's org; 404 if the workflow has been
 * garbage-collected; 500 on any other Temporal failure.
 * RPCError: re-raised on non-NOT_FOUND Temporal RPC errors so FastAPI
 * translates them to 500.
 */
export const getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGet = <ThrowOnError extends boolean = false>(options: Options<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetData, ThrowOnError>): RequestResult<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponses, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetErrors, ThrowOnError> => (options.client ?? client).get<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponses, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/lead-discovery/conversations/{conversation_id}/state',
    ...options
});

/**
 * End Conversation
 *
 * Signal the workflow to complete.
 *
 * Idempotent: an already-ended conversation still returns 204 — the
 * frontend fires this on dialog close and shouldn't have to know the
 * precise workflow state.
 *
 * Raises:
 * HTTPException: 400 if no organization; 403 if the
 * ``conversationId`` doesn't belong to the caller's org;
 * 500 on a non-NOT_FOUND Temporal RPC error.
 * RPCError: re-raised on non-NOT_FOUND Temporal RPC errors so FastAPI
 * translates them to 500.
 */
export const endConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPost = <ThrowOnError extends boolean = false>(options: Options<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData, ThrowOnError>): RequestResult<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponses, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostErrors, ThrowOnError> => (options.client ?? client).post<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponses, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zEndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/lead-discovery/conversations/{conversation_id}/end',
    ...options
});

/**
 * Get Account Processing Status
 *
 * Get processing workflow status for a specific account.
 *
 * Status is read directly from the DB processing_status column.
 *
 * Args:
 * account_id: The account ID to check status for.
 * session: SQLAlchemy async session.
 * permissions_service: Permissions service.
 *
 * Returns:
 * AccountProcessingStatusResponse with per-entity status information.
 *
 * Raises:
 * HTTPException: If account not found or user lacks access.
 */
export const getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetData, ThrowOnError>): RequestResult<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponses, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponses, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/processing-status/{account_id}',
    ...options
});

/**
 * Check Batch Status
 *
 * Check the overall processing status of an account's enrichment.
 *
 * Args:
 * account_id: The account ID to check.
 * session: SQLAlchemy async session.
 *
 * Returns:
 * Batch processing status.
 *
 * Raises:
 * HTTPException: If account not found.
 */
export const checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetData, ThrowOnError>): RequestResult<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponses, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponses, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponse.parseAsync(data),
    url: '/app/accounts/processing-status/batch/{account_id}',
    ...options
});

/**
 * Check Multiple Batch Status
 *
 * Check multiple batch processing statuses efficiently.
 *
 * Args:
 * account_ids: List of account IDs to check.
 * session: SQLAlchemy async session.
 *
 * Returns:
 * List of batch processing statuses.
 */
export const checkMultipleBatchStatusAppAccountsProcessingStatusBatchPost = <ThrowOnError extends boolean = false>(options: Options<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData, ThrowOnError>): RequestResult<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponses, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostErrors, ThrowOnError> => (options.client ?? client).post<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponses, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponse.parseAsync(data),
    url: '/app/accounts/processing-status/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Company Enrichment
 *
 * Retry enrichment for a company.
 *
 * Starts an EnrichmentDAGWorkflow in selective_refresh mode with no node_names
 * (runs all non-disabled nodes) for the given company. Also runs fit_analysis
 * for related accounts after company enrichment.
 *
 * Args:
 * company_id: The company ID to re-enrich.
 * session: SQLAlchemy async session.
 * temporal: Temporal client.
 *
 * Returns:
 * EnrichmentRetryResponse with workflow ID.
 *
 * Raises:
 * HTTPException: If enrichment is already in progress (409).
 */
export const retryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPost = <ThrowOnError extends boolean = false>(options: Options<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData, ThrowOnError>): RequestResult<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponses, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostErrors, ThrowOnError> => (options.client ?? client).post<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponses, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponse.parseAsync(data),
    url: '/app/accounts/processing-status/retry/company/{company_id}',
    ...options
});

/**
 * Retry Account Enrichment
 *
 * Retry enrichment for an account.
 *
 * Starts an EnrichmentDAGWorkflow with mode="initial_populate" for the account.
 * This will enrich the company and then run fit_analysis for the account.
 *
 * Args:
 * account_id: The account ID to re-enrich.
 * session: SQLAlchemy async session.
 * temporal: Temporal client.
 *
 * Returns:
 * EnrichmentRetryResponse with workflow ID.
 *
 * Raises:
 * HTTPException: If account not found (404) or enrichment already in progress (409).
 */
export const retryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPost = <ThrowOnError extends boolean = false>(options: Options<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData, ThrowOnError>): RequestResult<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponses, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostErrors, ThrowOnError> => (options.client ?? client).post<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponses, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponse.parseAsync(data),
    url: '/app/accounts/processing-status/retry/account/{account_id}',
    ...options
});

/**
 * Export Accounts
 *
 * Export accounts or contacts to CSV or Excel format.
 *
 * This endpoint supports two modes:
 * - accounts: One row per account (default)
 * - contacts: One row per contact with account data denormalized
 *
 * Args:
 * request: The request body containing the export request.
 * pg_search_service: The Postgres search service for querying accounts.
 * user_action_service: Service for logging user actions.
 * session: Database session for contact queries.
 * email_service: Email service for notifications.
 * permissions_service: Permissions service for tier gating.
 *
 * Returns:
 * CSV or Excel file containing the data.
 *
 * Raises:
 * HTTPException: If the user's organization is not on a paid tier.
 */
export const exportAccountsAppAccountsExportExportPost = <ThrowOnError extends boolean = false>(options: Options<ExportAccountsAppAccountsExportExportPostData, ThrowOnError>): RequestResult<ExportAccountsAppAccountsExportExportPostResponses, ExportAccountsAppAccountsExportExportPostErrors, ThrowOnError> => (options.client ?? client).post<ExportAccountsAppAccountsExportExportPostResponses, ExportAccountsAppAccountsExportExportPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExportAccountsAppAccountsExportExportPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Contacts
 *
 * Export contacts for an account to CSV or Excel format.
 *
 * This endpoint:
 * 1. Verifies user has access to the account
 * 2. Queries contacts for the account
 * 3. Optionally filters to selected contact IDs
 * 4. Formats data with account context (denormalized)
 * 5. Returns CSV or Excel file
 *
 * Returns:
 * CSV or Excel file containing the contacts for the account.
 *
 * Raises:
 * HTTPException: If the account is not found or the user does not have access to the account.
 */
export const exportContactsAppAccountsExportContactsPost = <ThrowOnError extends boolean = false>(options: Options<ExportContactsAppAccountsExportContactsPostData, ThrowOnError>): RequestResult<ExportContactsAppAccountsExportContactsPostResponses, ExportContactsAppAccountsExportContactsPostErrors, ThrowOnError> => (options.client ?? client).post<ExportContactsAppAccountsExportContactsPostResponses, ExportContactsAppAccountsExportContactsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExportContactsAppAccountsExportContactsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Export Emails
 *
 * Get email addresses for filtered accounts (for bulk email mailto).
 *
 * Returns a lightweight JSON response with unique professional email addresses
 * for all contacts linked to the filtered accounts.
 *
 * Args:
 * request: The request body containing filters.
 * pg_search_service: The Postgres search service for querying accounts.
 * session: Database session for contact queries.
 * permissions_service: Permissions service for tier gating.
 *
 * Returns:
 * ExportEmailsResponse with email addresses and counts.
 *
 * Raises:
 * HTTPException: If the user's organization is not on a paid tier.
 */
export const getExportEmailsAppAccountsExportEmailsPost = <ThrowOnError extends boolean = false>(options: Options<GetExportEmailsAppAccountsExportEmailsPostData, ThrowOnError>): RequestResult<GetExportEmailsAppAccountsExportEmailsPostResponses, GetExportEmailsAppAccountsExportEmailsPostErrors, ThrowOnError> => (options.client ?? client).post<GetExportEmailsAppAccountsExportEmailsPostResponses, GetExportEmailsAppAccountsExportEmailsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGetExportEmailsAppAccountsExportEmailsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetExportEmailsAppAccountsExportEmailsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/emails',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Custom Export Get Source Fields
 *
 * Return all SUPPLYCO fields available as a custom export template source field.
 *
 * Returns:
 * Source fields keyed by their export-row alias, with display labels.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGet = <ThrowOnError extends boolean = false>(options?: Options<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetData, ThrowOnError>): RequestResult<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/fields',
    ...options
});

/**
 * Custom Export Parse Template
 *
 * Parse an uploaded template CSV/Excel and return the header names.
 *
 * Only the header row is meaningful — data rows are ignored. Header parsing
 * is delegated to `DataExporter.parse_custom_export_headers`, which raises a
 * 400 on empty or headerless input.
 *
 * Returns:
 * The parsed column headers as plain strings.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportParseTemplateAppAccountsExportCustomExportParseTemplatePost = <ThrowOnError extends boolean = false>(options: Options<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData, ThrowOnError>): RequestResult<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponses, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostErrors, ThrowOnError> => (options.client ?? client).post<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponses, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zCustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/parse-template',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Custom Export Clear Template
 *
 * Clear the org's custom export template.
 *
 * Returns:
 * Empty 204 response.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportClearTemplateAppAccountsExportCustomExportTemplateDelete = <ThrowOnError extends boolean = false>(options?: Options<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData, ThrowOnError>): RequestResult<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/template',
    ...options
});

/**
 * Custom Export Get Template
 *
 * Return the org's saved custom export template, or null columns if unset.
 *
 * Returns:
 * Template response with the saved columns or null.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportGetTemplateAppAccountsExportCustomExportTemplateGet = <ThrowOnError extends boolean = false>(options?: Options<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetData, ThrowOnError>): RequestResult<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/template',
    ...options
});

/**
 * Custom Export Save Template
 *
 * Upsert the org's custom export template.
 *
 * Args:
 * template: Validated template payload.
 * user: The current org user.
 * session: Database session.
 * permissions_service: Permissions check for tier gating.
 *
 * Returns:
 * The saved template echoed back.
 *
 * Raises:
 * HTTPException: 400 if any source_field references an unknown SUPPLYCO key.
 */
export const customExportSaveTemplateAppAccountsExportCustomExportTemplatePut = <ThrowOnError extends boolean = false>(options: Options<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData, ThrowOnError>): RequestResult<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponses, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutErrors, ThrowOnError> => (options.client ?? client).put<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponses, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Custom Export Preview
 *
 * Return populated grid rows for the given account scope and saved template.
 *
 * See ``_load_custom_export_data`` for the 403 / 409 error contract shared
 * with the download endpoint.
 *
 * Returns:
 * Preview rows keyed by template target headers.
 */
export const customExportPreviewAppAccountsExportCustomExportPreviewPost = <ThrowOnError extends boolean = false>(options: Options<CustomExportPreviewAppAccountsExportCustomExportPreviewPostData, ThrowOnError>): RequestResult<CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponses, CustomExportPreviewAppAccountsExportCustomExportPreviewPostErrors, ThrowOnError> => (options.client ?? client).post<CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponses, CustomExportPreviewAppAccountsExportCustomExportPreviewPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCustomExportPreviewAppAccountsExportCustomExportPreviewPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCustomExportPreviewAppAccountsExportCustomExportPreviewPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Custom Export Download
 *
 * Stream the final custom export file (CSV or Excel) with user edits applied.
 *
 * See ``_load_custom_export_data`` for the 403 / 409 error contract shared
 * with the preview endpoint.
 *
 * Returns:
 * StreamingResponse containing the populated file, or 204 if no accounts match.
 */
export const customExportDownloadAppAccountsExportCustomExportDownloadPost = <ThrowOnError extends boolean = false>(options: Options<CustomExportDownloadAppAccountsExportCustomExportDownloadPostData, ThrowOnError>): RequestResult<CustomExportDownloadAppAccountsExportCustomExportDownloadPostResponses, CustomExportDownloadAppAccountsExportCustomExportDownloadPostErrors, ThrowOnError> => (options.client ?? client).post<CustomExportDownloadAppAccountsExportCustomExportDownloadPostResponses, CustomExportDownloadAppAccountsExportCustomExportDownloadPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCustomExportDownloadAppAccountsExportCustomExportDownloadPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/export/custom-export/download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Account Facet Options
 *
 * Get options for a single account filter facet.
 *
 * Returns:
 * Option values for the requested facet.
 */
export const getAccountFacetOptionsAppAccountsFilterOptionsFacetPost = <ThrowOnError extends boolean = false>(options: Options<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData, ThrowOnError>): RequestResult<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponses, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostErrors, ThrowOnError> => (options.client ?? client).post<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponses, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostBody.optional(),
        path: zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/filter-options/{facet}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Accounts Heat Map
 *
 * Aggregate account applications into an application x NAICS-subsector grid.
 *
 * Returns:
 * Non-empty cells with weighted, stated and raw account counts.
 *
 * Raises:
 * HTTPException: If the user has no organization.
 */
export const getAccountsHeatMapAppAccountsHeatMapsPost = <ThrowOnError extends boolean = false>(options?: Options<GetAccountsHeatMapAppAccountsHeatMapsPostData, ThrowOnError>): RequestResult<GetAccountsHeatMapAppAccountsHeatMapsPostResponses, GetAccountsHeatMapAppAccountsHeatMapsPostErrors, ThrowOnError> => (options?.client ?? client).post<GetAccountsHeatMapAppAccountsHeatMapsPostResponses, GetAccountsHeatMapAppAccountsHeatMapsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGetAccountsHeatMapAppAccountsHeatMapsPostBody.optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountsHeatMapAppAccountsHeatMapsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/heat-maps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Parse Filters
 *
 * Parse a natural language query into structured account filters.
 *
 * Returns:
 * ParseFiltersResponse with extracted filters.
 *
 * Raises:
 * HTTPException: If organization not found (400) or AI unavailable (503).
 */
export const parseFiltersAppAccountsParseFiltersPost = <ThrowOnError extends boolean = false>(options: Options<ParseFiltersAppAccountsParseFiltersPostData, ThrowOnError>): RequestResult<ParseFiltersAppAccountsParseFiltersPostResponses, ParseFiltersAppAccountsParseFiltersPostErrors, ThrowOnError> => (options.client ?? client).post<ParseFiltersAppAccountsParseFiltersPostResponses, ParseFiltersAppAccountsParseFiltersPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zParseFiltersAppAccountsParseFiltersPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zParseFiltersAppAccountsParseFiltersPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/parse-filters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Vector Tile
 *
 * Get vector tile for map visualization.
 *
 * Generates clustered 'clusters' and 'points' layers using PostGIS ST_AsMVT
 * over the accounts returned by the shared map query, so the pins here always
 * match the accounts ``/map-points`` lists for the same filters.
 *
 * Returns:
 * Response: MVT protobuf content.
 *
 * Raises:
 * HTTPException: If organization not found or query fails.
 */
export const getVectorTileAppAccountsAccountsTilesZXYPbfGet = <ThrowOnError extends boolean = false>(options: Options<GetVectorTileAppAccountsAccountsTilesZxyPbfGetData, ThrowOnError>): RequestResult<GetVectorTileAppAccountsAccountsTilesZxyPbfGetResponses, GetVectorTileAppAccountsAccountsTilesZxyPbfGetErrors, ThrowOnError> => (options.client ?? client).get<GetVectorTileAppAccountsAccountsTilesZxyPbfGetResponses, GetVectorTileAppAccountsAccountsTilesZxyPbfGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetVectorTileAppAccountsAccountsTilesZxyPbfGetPath,
        query: zGetVectorTileAppAccountsAccountsTilesZxyPbfGetQuery.optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/tiles/{z}/{x}/{y}.pbf',
    ...options
});

/**
 * Share Accounts
 *
 * Share accounts with a distributor organization.
 *
 * This endpoint:
 * 1. Validates user has permission to share the accounts
 * 2. Verifies target organization is a distributor of the user's organization
 * 3. Creates share records with the distributor organization
 * 4. Sends email notification to the distributor organization
 *
 * Supports two modes:
 * 1. Share specific accounts by providing account IDs
 * 2. Bulk share by providing filters (shares all accounts matching filters)
 *
 * Returns:
 * ShareAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If distributor organization is not found (404)
 */
export const shareAccountsAppAccountsSharePost = <ThrowOnError extends boolean = false>(options: Options<ShareAccountsAppAccountsSharePostData, ThrowOnError>): RequestResult<ShareAccountsAppAccountsSharePostResponses, ShareAccountsAppAccountsSharePostErrors, ThrowOnError> => (options.client ?? client).post<ShareAccountsAppAccountsSharePostResponses, ShareAccountsAppAccountsSharePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zShareAccountsAppAccountsSharePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zShareAccountsAppAccountsSharePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/share/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Share Account Via Email
 *
 * Render email template for sharing account details via a client-side mailto link.
 *
 * Returns:
 * ShareAccountViaEmailResponse with rendered subject/text/html.
 */
export const shareAccountViaEmailAppAccountsShareAccountIdEmailPost = <ThrowOnError extends boolean = false>(options: Options<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData, ThrowOnError>): RequestResult<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponses, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostErrors, ThrowOnError> => (options.client ?? client).post<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponses, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zShareAccountViaEmailAppAccountsShareAccountIdEmailPostBody,
        path: zShareAccountViaEmailAppAccountsShareAccountIdEmailPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/share/{account_id}/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Account Contacts
 *
 * Get contacts for an account.
 *
 * Returns:
 * Page[ContactDetails] instance.
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsAppAccountsContactsAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountContactsAppAccountsContactsAccountIdGetData, ThrowOnError>): RequestResult<GetAccountContactsAppAccountsContactsAccountIdGetResponses, GetAccountContactsAppAccountsContactsAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountContactsAppAccountsContactsAccountIdGetResponses, GetAccountContactsAppAccountsContactsAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountContactsAppAccountsContactsAccountIdGetPath,
        query: zGetAccountContactsAppAccountsContactsAccountIdGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountContactsAppAccountsContactsAccountIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}',
    ...options
});

/**
 * Get Account Contacts Full
 *
 * Get all contacts for an account, fetching from Explorium if needed.
 *
 * Returns:
 * Page of ContactDetails for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsFullAppAccountsContactsAccountIdFullGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData, ThrowOnError>): RequestResult<GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponses, GetAccountContactsFullAppAccountsContactsAccountIdFullGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponses, GetAccountContactsFullAppAccountsContactsAccountIdFullGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountContactsFullAppAccountsContactsAccountIdFullGetPath,
        query: zGetAccountContactsFullAppAccountsContactsAccountIdFullGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/full',
    ...options
});

/**
 * Get Account Contacts Summary
 *
 * Get lightweight contact summaries for an account table view.
 *
 * Returns only the fields needed for the contacts table, omitting heavy
 * array fields (skills, experience, interests, functions, emails) to
 * reduce HTTP payload size.
 *
 * Returns:
 * Page of ContactSummary for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet = <ThrowOnError extends boolean = false>(options: Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData, ThrowOnError>): RequestResult<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponses, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponses, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetPath,
        query: zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/summary',
    ...options
});

/**
 * Get Contact Detail
 *
 * Get full contact details for a single person.
 *
 * Used by the contact detail sheet to lazy-load all fields for one contact.
 *
 * Returns:
 * ContactDetails with all fields for the person.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const getContactDetailAppAccountsContactsAccountIdDetailPersonIdGet = <ThrowOnError extends boolean = false>(options: Options<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetData, ThrowOnError>): RequestResult<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponses, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponses, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/detail/{person_id}',
    ...options
});

/**
 * Fetch More Contacts
 *
 * Fetch the next batch of contacts from Explorium for an account.
 *
 * Returns:
 * Page of newly fetched ContactDetails.
 *
 * Raises:
 * HTTPException: If account not found, no business ID, or permission denied.
 */
export const fetchMoreContactsAppAccountsContactsAccountIdFetchMorePost = <ThrowOnError extends boolean = false>(options: Options<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData, ThrowOnError>): RequestResult<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponses, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostErrors, ThrowOnError> => (options.client ?? client).post<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponses, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostPath,
        query: zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/fetch-more',
    ...options
});

/**
 * Enrich Contact
 *
 * Enrich a single contact with email/phone data from Explorium.
 *
 * Returns:
 * ContactDetails with enriched data.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const enrichContactAppAccountsContactsAccountIdEnrichPersonIdPost = <ThrowOnError extends boolean = false>(options: Options<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData, ThrowOnError>): RequestResult<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponses, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostErrors, ThrowOnError> => (options.client ?? client).post<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponses, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zEnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/enrich/{person_id}',
    ...options
});

/**
 * Set Primary Contact
 *
 * Set a contact as the primary contact for an account.
 *
 * Replaces any existing primary contact for this account.
 *
 * Returns:
 * ContactDetails for the newly set primary contact.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const setPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPut = <ThrowOnError extends boolean = false>(options: Options<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData, ThrowOnError>): RequestResult<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponses, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutErrors, ThrowOnError> => (options.client ?? client).put<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponses, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/primary/{person_id}',
    ...options
});

/**
 * Unset Primary Contact
 *
 * Remove the primary contact designation for an account.
 *
 * Returns:
 * 204 No Content on success.
 *
 * Raises:
 * HTTPException: If account not found or permission denied.
 */
export const unsetPrimaryContactAppAccountsContactsAccountIdPrimaryDelete = <ThrowOnError extends boolean = false>(options: Options<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData, ThrowOnError>): RequestResult<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteResponses, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteResponses, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zUnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/contacts/{account_id}/primary',
    ...options
});

/**
 * List Notes
 *
 * List notes for an account, sorted by most recent first.
 *
 * Returns:
 * List of account notes.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const listNotesAppAccountsNotesAccountIdGet = <ThrowOnError extends boolean = false>(options: Options<ListNotesAppAccountsNotesAccountIdGetData, ThrowOnError>): RequestResult<ListNotesAppAccountsNotesAccountIdGetResponses, ListNotesAppAccountsNotesAccountIdGetErrors, ThrowOnError> => (options.client ?? client).get<ListNotesAppAccountsNotesAccountIdGetResponses, ListNotesAppAccountsNotesAccountIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListNotesAppAccountsNotesAccountIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListNotesAppAccountsNotesAccountIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/notes/{account_id}',
    ...options
});

/**
 * Create Note
 *
 * Create a note on an account.
 *
 * Returns:
 * The created note.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const createNoteAppAccountsNotesAccountIdPost = <ThrowOnError extends boolean = false>(options: Options<CreateNoteAppAccountsNotesAccountIdPostData, ThrowOnError>): RequestResult<CreateNoteAppAccountsNotesAccountIdPostResponses, CreateNoteAppAccountsNotesAccountIdPostErrors, ThrowOnError> => (options.client ?? client).post<CreateNoteAppAccountsNotesAccountIdPostResponses, CreateNoteAppAccountsNotesAccountIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateNoteAppAccountsNotesAccountIdPostBody,
        path: zCreateNoteAppAccountsNotesAccountIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateNoteAppAccountsNotesAccountIdPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/notes/{account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Note
 *
 * Soft-delete a note. Only the note author can delete their own notes.
 *
 * Returns:
 * The soft-deleted note.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if not author, 404 if not found.
 */
export const deleteNoteAppAccountsNotesAccountIdNoteIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData, ThrowOnError>): RequestResult<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponses, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponses, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteNoteAppAccountsNotesAccountIdNoteIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/notes/{account_id}/{note_id}',
    ...options
});

/**
 * Delete Accounts
 *
 * Delete multiple accounts (soft delete).
 *
 * This endpoint:
 * 1. Validates user has permission to delete the accounts
 * 2. Soft deletes accounts by setting deleted_at timestamp
 * 3. Returns confirmation of deletion
 *
 * Supports two modes:
 * 1. Delete specific accounts by providing account IDs
 * 2. Bulk delete by providing filters (deletes all accounts matching filters)
 *
 * Returns:
 * DeleteAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If accounts not found (404) or user lacks permission (403).
 */
export const deleteAccountsAppAccountsDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountsAppAccountsDeleteData, ThrowOnError>): RequestResult<DeleteAccountsAppAccountsDeleteResponses, DeleteAccountsAppAccountsDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAccountsAppAccountsDeleteResponses, DeleteAccountsAppAccountsDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zDeleteAccountsAppAccountsDeleteBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteAccountsAppAccountsDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger Supplier Lookup
 *
 * Trigger a Gemini grounded search for suppliers of the account's company.
 *
 * Returns immediately with a PENDING lookup; the search runs in the background.
 *
 * Returns:
 * The pending supplier lookup record.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access, 404 if no company.
 */
export const triggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPost = <ThrowOnError extends boolean = false>(options: Options<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData, ThrowOnError>): RequestResult<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponses, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostErrors, ThrowOnError> => (options.client ?? client).post<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponses, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zTriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/supplier-lookup',
    ...options
});

/**
 * List Supplier Lookups
 *
 * List previous supplier lookups for an account.
 *
 * Returns:
 * List of supplier lookups, most recent first.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGet = <ThrowOnError extends boolean = false>(options: Options<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetData, ThrowOnError>): RequestResult<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponses, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetErrors, ThrowOnError> => (options.client ?? client).get<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponses, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/supplier-lookups',
    ...options
});

/**
 * Track Account View
 *
 * Track that a user viewed an account page.
 *
 * Creates a new action record each time, allowing for view count analytics.
 *
 * Raises:
 * HTTPException: If the account is not found or doesn't belong to user's org.
 */
export const trackAccountViewAppAccountsAccountsAccountIdViewPost = <ThrowOnError extends boolean = false>(options: Options<TrackAccountViewAppAccountsAccountsAccountIdViewPostData, ThrowOnError>): RequestResult<TrackAccountViewAppAccountsAccountsAccountIdViewPostResponses, TrackAccountViewAppAccountsAccountsAccountIdViewPostErrors, ThrowOnError> => (options.client ?? client).post<TrackAccountViewAppAccountsAccountsAccountIdViewPostResponses, TrackAccountViewAppAccountsAccountsAccountIdViewPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zTrackAccountViewAppAccountsAccountsAccountIdViewPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/view',
    ...options
});

/**
 * Get Building Footprint
 *
 * Get the building footprint for an account's company, if one is matched.
 *
 * Returns:
 * BuildingFootprintResponse | None: The footprint polygon and
 * attributes, or null when no footprint has been matched.
 *
 * Raises:
 * HTTPException: 404 if the account is not found in the user's org.
 */
export const getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGet = <ThrowOnError extends boolean = false>(options: Options<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetData, ThrowOnError>): RequestResult<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponses, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetErrors, ThrowOnError> => (options.client ?? client).get<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponses, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/accounts/accounts/{account_id}/building-footprint',
    ...options
});

/**
 * List Agent Runs
 *
 * Return the most recent agent runs for the actor's organization.
 *
 * Returns:
 * Up to ``limit`` runs, newest first.
 *
 * Raises:
 * HTTPException: 403 if the actor has no organization context.
 */
export const listAgentRunsAppAgentRunsGet = <ThrowOnError extends boolean = false>(options?: Options<ListAgentRunsAppAgentRunsGetData, ThrowOnError>): RequestResult<ListAgentRunsAppAgentRunsGetResponses, ListAgentRunsAppAgentRunsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListAgentRunsAppAgentRunsGetResponses, ListAgentRunsAppAgentRunsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListAgentRunsAppAgentRunsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListAgentRunsAppAgentRunsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/agent-runs',
    ...options
});

/**
 * Launch Agent Run
 *
 * Start an agent workflow and return its newly-created run summary.
 *
 * The frontend uses the returned ``id`` to navigate straight to the
 * detail page, where it'll start streaming events as they arrive.
 *
 * Returns:
 * Summary of the newly-created agent run (status will be RUNNING
 * by the time this returns).
 *
 * Raises:
 * HTTPException: 403 if no org context, 400 if agent_name is unknown
 * or required fields are missing, 504 if the run row didn't
 * materialize within the deadline.
 */
export const launchAgentRunAppAgentRunsLaunchPost = <ThrowOnError extends boolean = false>(options: Options<LaunchAgentRunAppAgentRunsLaunchPostData, ThrowOnError>): RequestResult<LaunchAgentRunAppAgentRunsLaunchPostResponses, LaunchAgentRunAppAgentRunsLaunchPostErrors, ThrowOnError> => (options.client ?? client).post<LaunchAgentRunAppAgentRunsLaunchPostResponses, LaunchAgentRunAppAgentRunsLaunchPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zLaunchAgentRunAppAgentRunsLaunchPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLaunchAgentRunAppAgentRunsLaunchPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/agent-runs/launch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Respond To Agent Run
 *
 * Signal a paused agent workflow with the user's decision.
 *
 * Scripted demos like demo_2 pause at human-in-the-loop steps via
 * ``workflow.wait_condition``; this endpoint forwards the UI's
 * response as a Temporal ``respond`` signal so the workflow can
 * advance.
 *
 * Returns:
 * ``204 No Content`` on successful signal dispatch.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in
 * the org, 502 if Temporal can't be reached or the workflow
 * isn't running.
 */
export const respondToAgentRunAppAgentRunsRunIdRespondPost = <ThrowOnError extends boolean = false>(options: Options<RespondToAgentRunAppAgentRunsRunIdRespondPostData, ThrowOnError>): RequestResult<RespondToAgentRunAppAgentRunsRunIdRespondPostResponses, RespondToAgentRunAppAgentRunsRunIdRespondPostErrors, ThrowOnError> => (options.client ?? client).post<RespondToAgentRunAppAgentRunsRunIdRespondPostResponses, RespondToAgentRunAppAgentRunsRunIdRespondPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zRespondToAgentRunAppAgentRunsRunIdRespondPostBody,
        path: zRespondToAgentRunAppAgentRunsRunIdRespondPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRespondToAgentRunAppAgentRunsRunIdRespondPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/agent-runs/{run_id}/respond',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Agent Run
 *
 * Return a single agent run plus its full event log.
 *
 * Returns:
 * The run row plus all persisted events in chronological order.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in the org.
 */
export const getAgentRunAppAgentRunsRunIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAgentRunAppAgentRunsRunIdGetData, ThrowOnError>): RequestResult<GetAgentRunAppAgentRunsRunIdGetResponses, GetAgentRunAppAgentRunsRunIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetAgentRunAppAgentRunsRunIdGetResponses, GetAgentRunAppAgentRunsRunIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAgentRunAppAgentRunsRunIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAgentRunAppAgentRunsRunIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/agent-runs/{run_id}',
    ...options
});

/**
 * Stream Agent Run
 *
 * Server-Sent Events: replay then live-tail an agent run's events.
 *
 * Returns:
 * An EventSourceResponse that emits one SSE frame per event.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in the org.
 */
export const streamAgentRunAppAgentRunsRunIdStreamGet = <ThrowOnError extends boolean = false>(options: Options<StreamAgentRunAppAgentRunsRunIdStreamGetData, ThrowOnError>): RequestResult<StreamAgentRunAppAgentRunsRunIdStreamGetResponses, StreamAgentRunAppAgentRunsRunIdStreamGetErrors, ThrowOnError> => (options.client ?? client).get<StreamAgentRunAppAgentRunsRunIdStreamGetResponses, StreamAgentRunAppAgentRunsRunIdStreamGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zStreamAgentRunAppAgentRunsRunIdStreamGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/agent-runs/{run_id}/stream',
    ...options
});

/**
 * Get Company Info
 *
 * Get company info for the current user's organization.
 *
 * Returns None if no company info exists yet.
 * Any member of the organization can view company info.
 *
 * Returns:
 * CompanyInfoResponse if found/successful, None otherwise.
 */
export const getCompanyInfoAppOrganizationCompanyInfoGet = <ThrowOnError extends boolean = false>(options?: Options<GetCompanyInfoAppOrganizationCompanyInfoGetData, ThrowOnError>): RequestResult<GetCompanyInfoAppOrganizationCompanyInfoGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCompanyInfoAppOrganizationCompanyInfoGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCompanyInfoAppOrganizationCompanyInfoGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/company-info/',
    ...options
});

/**
 * Update Company Info
 *
 * Update company info for the current user's organization.
 *
 * Only updates existing records. Only org admins can update.
 *
 * Returns:
 * CompanyInfoResponse instance.
 *
 * Raises:
 * HTTPException: If permission denied (403) or no company info exists (404).
 */
export const updateCompanyInfoAppOrganizationCompanyInfoPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyInfoAppOrganizationCompanyInfoPatchData, ThrowOnError>): RequestResult<UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponses, UpdateCompanyInfoAppOrganizationCompanyInfoPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponses, UpdateCompanyInfoAppOrganizationCompanyInfoPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateCompanyInfoAppOrganizationCompanyInfoPatchBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateCompanyInfoAppOrganizationCompanyInfoPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/company-info/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Distributors
 *
 * Get all channel partners for the current user's organization.
 *
 * Returns both:
 * - Distributors: orgs that distribute FOR us (we are the supplier)
 * - Suppliers: orgs that supply TO us (we are the distributor)
 *
 * Any organization member can view channel partners.
 *
 * Returns:
 * list[DistributorOrganizationResponse] with direction field indicating relationship type.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const getDistributorsAppOrganizationOrganizationsDistributorsGet = <ThrowOnError extends boolean = false>(options?: Options<GetDistributorsAppOrganizationOrganizationsDistributorsGetData, ThrowOnError>): RequestResult<GetDistributorsAppOrganizationOrganizationsDistributorsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDistributorsAppOrganizationOrganizationsDistributorsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetDistributorsAppOrganizationOrganizationsDistributorsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/distributors',
    ...options
});

/**
 * Update Distributor Relationship
 *
 * Update a distributor relationship (e.g., set default PoC).
 *
 * Only admins of the supplier organization can update the relationship.
 * The PoC user must belong to the distributor organization.
 *
 * Returns:
 * Updated DistributorOrganizationResponse.
 *
 * Raises:
 * HTTPException: If permission denied (403), relationship not found (404),
 * or PoC user not in distributor org (400).
 */
export const updateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData, ThrowOnError>): RequestResult<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponses, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponses, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchBody,
        path: zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/distributors/{relationship_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Assignable Users
 *
 * Get all users who can be assigned to accounts.
 *
 * Returns users from:
 * - The current user's organization
 * - Related organizations (distributors if OEM, suppliers if distributor)
 *
 * This enables cross-org assignment for shared accounts.
 *
 * Returns:
 * AssignableUsersResponse with list of assignable users.
 *
 * Raises:
 * HTTPException: If user is not in an organization (403).
 */
export const getAssignableUsersAppOrganizationOrganizationsAssignableUsersGet = <ThrowOnError extends boolean = false>(options?: Options<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetData, ThrowOnError>): RequestResult<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/assignable-users',
    ...options
});

/**
 * Update Organization
 *
 * Update organization details. Requires JWT Bearer authentication and superuser privileges.
 */
export const updateOrganizationAppOrganizationOrganizationsOrgIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData, ThrowOnError>): RequestResult<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponses, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponses, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchBody,
        path: zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/{org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organization Info
 *
 * Get organization info including members and company details.
 *
 * Returns:
 * OrganizationInfoResponse with organization, company_info, and members.
 *
 * Raises:
 * HTTPException: If permission denied (403) or organization not found (404).
 */
export const getOrganizationInfoAppOrganizationOrganizationsInfoGet = <ThrowOnError extends boolean = false>(options?: Options<GetOrganizationInfoAppOrganizationOrganizationsInfoGetData, ThrowOnError>): RequestResult<GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOrganizationInfoAppOrganizationOrganizationsInfoGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/info',
    ...options
});

/**
 * Update Member Role
 *
 * Update a member's role within the organization.
 *
 * Superusers can update any user's role. Organization admins can only
 * update roles for users in their own organization.
 * Users cannot change their own role.
 *
 * Returns:
 * OrganizationMember with updated role.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * or user tries to change their own role (400).
 */
export const updateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatch = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData, ThrowOnError>): RequestResult<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponses, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponses, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchBody,
        path: zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/members/{user_id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Member Invitation
 *
 * Resend invitation email to an organization member.
 *
 * Only works for unverified users. For verified users, use reset-password instead.
 * Only organization admins can resend invitations.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * user already verified (400), or user not in organization.
 */
export const resendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPost = <ThrowOnError extends boolean = false>(options: Options<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData, ThrowOnError>): RequestResult<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponses, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostErrors, ThrowOnError> => (options.client ?? client).post<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponses, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/members/{user_id}/resend-invitation',
    ...options
});

/**
 * Delete Member
 *
 * Remove a user from the organization and deactivate their account.
 *
 * Removes the user from the organization (sets organization_id=NULL)
 * and deactivates them (sets is_active=False). The user will no longer
 * be able to log in.
 *
 * Superusers can delete any user. Organization admins can only delete
 * users in their own organization. Users cannot delete themselves.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * or user tries to delete themselves (400).
 */
export const deleteMemberAppOrganizationOrganizationsMembersUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData, ThrowOnError>): RequestResult<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponses, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponses, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteMemberAppOrganizationOrganizationsMembersUserIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/members/{user_id}',
    ...options
});

/**
 * Create Member
 *
 * Add a new member to an organization.
 *
 * Org admins can only add to their own organization.
 * Superusers can specify any organization_id.
 *
 * Note: Org admins can assign any role including ADMIN to new members.
 *
 * Returns:
 * CreateMemberResponse with the created member.
 *
 * Raises:
 * HTTPException: If permission denied (403), seat limit exceeded (400),
 * or user already exists (409).
 */
export const createMemberAppOrganizationOrganizationsMembersPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberAppOrganizationOrganizationsMembersPostData, ThrowOnError>): RequestResult<CreateMemberAppOrganizationOrganizationsMembersPostResponses, CreateMemberAppOrganizationOrganizationsMembersPostErrors, ThrowOnError> => (options.client ?? client).post<CreateMemberAppOrganizationOrganizationsMembersPostResponses, CreateMemberAppOrganizationOrganizationsMembersPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateMemberAppOrganizationOrganizationsMembersPostBody,
        path: z.never().optional(),
        query: zCreateMemberAppOrganizationOrganizationsMembersPostQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateMemberAppOrganizationOrganizationsMembersPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Inbound Config
 *
 * Return the caller org's inbound-email configuration.
 *
 * Returns:
 * Composed forwarding address, slug, and allowlist state.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if org row missing.
 */
export const getInboundConfigAppOrganizationOrganizationsMeInboundConfigGet = <ThrowOnError extends boolean = false>(options?: Options<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetData, ThrowOnError>): RequestResult<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/me/inbound-config',
    ...options
});

/**
 * Update Inbound Config
 *
 * Update inbound-email configuration. Admin-only.
 *
 * Only the forwarder allowlist is mutable here; the slug is fixed.
 *
 * Returns:
 * Updated configuration snapshot.
 *
 * Raises:
 * HTTPException: 403 if not admin, 404 if org missing.
 */
export const updateInboundConfigAppOrganizationOrganizationsMeInboundConfigPut = <ThrowOnError extends boolean = false>(options: Options<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData, ThrowOnError>): RequestResult<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponses, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponses, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/me/inbound-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Required Order Fields
 *
 * Return the caller-org's per-document-type required-field config.
 *
 * Visible to every authenticated org user (read is not gated to
 * admins) so the order detail panel can render the per-field
 * "Required" badge for everyone — only edits are admin-only.
 *
 * Returns:
 * Map of document type → list of camelCase field IDs that are
 * currently required.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if org row missing.
 */
export const getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGet = <ThrowOnError extends boolean = false>(options?: Options<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetData, ThrowOnError>): RequestResult<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/me/required-order-fields',
    ...options
});

/**
 * Update Required Order Field
 *
 * Toggle one field required for ``document_type``. Admin only.
 *
 * Idempotent on re-toggle: setting required=True when already required
 * is a no-op (and vice versa). When
 * ``apply_to_all_document_types`` is true the same toggle is applied
 * to every :class:`DocumentType` in one transaction.
 *
 * Returns:
 * Updated full config snapshot.
 *
 * Raises:
 * HTTPException: 400 if ``field_id`` is not in
 * :data:`REQUIREABLE_FIELDS` (rejecting unknown / non-header
 * fields up front avoids storing config the UI can't render
 * and the review engine would silently drop). 403 if not
 * admin or no org context. 404 if org row missing.
 */
export const updateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData, ThrowOnError>): RequestResult<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponses, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponses, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutBody,
        path: zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/organizations/me/required-order-fields/{document_type}/{field_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Personas
 *
 * Get all personas for an organization.
 *
 * Requires organization membership.
 * Returns only non-hidden personas ordered by creation date (newest first).
 * Status is derived from Temporal workflow state.
 *
 * Returns:
 * list[PersonaResponse] instance.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const getPersonasAppOrganizationPersonasGet = <ThrowOnError extends boolean = false>(options?: Options<GetPersonasAppOrganizationPersonasGetData, ThrowOnError>): RequestResult<GetPersonasAppOrganizationPersonasGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPersonasAppOrganizationPersonasGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPersonasAppOrganizationPersonasGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/personas/',
    ...options
});

/**
 * Create Persona
 *
 * Create a new persona for an organization.
 *
 * Requires admin role in the organization.
 * Persona filter generation is dispatched immediately to Temporal.
 *
 * Returns:
 * PersonaResponse instance with status PENDING.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const createPersonaAppOrganizationPersonasPost = <ThrowOnError extends boolean = false>(options: Options<CreatePersonaAppOrganizationPersonasPostData, ThrowOnError>): RequestResult<CreatePersonaAppOrganizationPersonasPostResponses, CreatePersonaAppOrganizationPersonasPostErrors, ThrowOnError> => (options.client ?? client).post<CreatePersonaAppOrganizationPersonasPostResponses, CreatePersonaAppOrganizationPersonasPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreatePersonaAppOrganizationPersonasPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePersonaAppOrganizationPersonasPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/personas/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Persona
 *
 * Delete a persona.
 *
 * Requires admin role in the organization.
 * Permanently deletes the persona.
 *
 * Raises:
 * HTTPException: If permission denied (403) or persona not found (404).
 */
export const deletePersonaAppOrganizationPersonasPersonaIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePersonaAppOrganizationPersonasPersonaIdDeleteData, ThrowOnError>): RequestResult<DeletePersonaAppOrganizationPersonasPersonaIdDeleteResponses, DeletePersonaAppOrganizationPersonasPersonaIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeletePersonaAppOrganizationPersonasPersonaIdDeleteResponses, DeletePersonaAppOrganizationPersonasPersonaIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeletePersonaAppOrganizationPersonasPersonaIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/personas/{persona_id}',
    ...options
});

/**
 * Delete Distributor Relationship
 *
 * Soft delete a distributor relationship and revoke associated shares.
 *
 * Only admins of the supplier organization can delete the relationship.
 * This soft-deletes the relationship (sets deleted_at/deleted_by) and
 * revokes all account shares with the distributor organization.
 *
 * Args:
 * relationship_id: ID of the relationship to delete
 * session: Async database session
 * current_user: Authenticated user making the request
 * user_action_service: Service for logging user actions
 *
 * Raises:
 * HTTPException: If user is not an admin (403), relationship not found (404),
 * or distributor organization not found (404)
 */
export const deleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData, ThrowOnError>): RequestResult<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteResponses, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteResponses, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/distributor-relationships/{relationship_id}',
    ...options
});

/**
 * Create Distributor Relationship
 *
 * Create a distributor relationship between organizations.
 *
 * Org admins can add distributors to their own organization.
 * Superusers can specify any supplier_org_id.
 *
 * Returns:
 * DistributorOrganizationResponse with the created relationship.
 *
 * Raises:
 * HTTPException: If permission denied (403), org not found (404),
 * self-relationship attempted (400), or duplicate relationship (409).
 */
export const createDistributorRelationshipAppOrganizationDistributorRelationshipsPost = <ThrowOnError extends boolean = false>(options: Options<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData, ThrowOnError>): RequestResult<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponses, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponses, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/organization/distributor-relationships/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Log Activity Actions
 *
 * Log activity actions for a list of accounts.
 *
 * Uses junction table for bulk operations (1 action + N items).
 * Deduplicates CONTACTED actions: same user + same contact info within 5 minutes.
 *
 * Returns:
 * ActivityActionResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to create activity actions.
 */
export const logActivityActionsAppAccountActionsActivityActionsPost = <ThrowOnError extends boolean = false>(options: Options<LogActivityActionsAppAccountActionsActivityActionsPostData, ThrowOnError>): RequestResult<LogActivityActionsAppAccountActionsActivityActionsPostResponses, LogActivityActionsAppAccountActionsActivityActionsPostErrors, ThrowOnError> => (options.client ?? client).post<LogActivityActionsAppAccountActionsActivityActionsPostResponses, LogActivityActionsAppAccountActionsActivityActionsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zLogActivityActionsAppAccountActionsActivityActionsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLogActivityActionsAppAccountActionsActivityActionsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Activity Leaderboard
 *
 * Get activity leaderboard for an organization.
 *
 * Returns:
 * LeaderboardResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity leaderboard.
 * HTTPException: If the organization is not found.
 */
export const getActivityLeaderboardAppAccountActionsActivityLeaderboardGet = <ThrowOnError extends boolean = false>(options?: Options<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetData, ThrowOnError>): RequestResult<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponses, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetErrors, ThrowOnError> => (options?.client ?? client).get<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponses, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetActivityLeaderboardAppAccountActionsActivityLeaderboardGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/leaderboard',
    ...options
});

/**
 * Get Activity Stats
 *
 * Get activity stats for an organization.
 *
 * Returns:
 * ActivityStatsResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity stats.
 */
export const getActivityStatsAppAccountActionsActivityStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetActivityStatsAppAccountActionsActivityStatsGetData, ThrowOnError>): RequestResult<GetActivityStatsAppAccountActionsActivityStatsGetResponses, GetActivityStatsAppAccountActionsActivityStatsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetActivityStatsAppAccountActionsActivityStatsGetResponses, GetActivityStatsAppAccountActionsActivityStatsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetActivityStatsAppAccountActionsActivityStatsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetActivityStatsAppAccountActionsActivityStatsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/stats',
    ...options
});

/**
 * Get Activity Timeline
 *
 * Get activity timeline data for charting outreach over time.
 *
 * Returns daily contact counts per user/distributor for the specified period.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * include_distributors: Whether to include distributor organizations.
 * days: Number of days to include. None means all time.
 *
 * Returns:
 * ActivityTimelineResponse with series data for each rep/distributor.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity timeline.
 */
export const getActivityTimelineAppAccountActionsActivityTimelineGet = <ThrowOnError extends boolean = false>(options?: Options<GetActivityTimelineAppAccountActionsActivityTimelineGetData, ThrowOnError>): RequestResult<GetActivityTimelineAppAccountActionsActivityTimelineGetResponses, GetActivityTimelineAppAccountActionsActivityTimelineGetErrors, ThrowOnError> => (options?.client ?? client).get<GetActivityTimelineAppAccountActionsActivityTimelineGetResponses, GetActivityTimelineAppAccountActionsActivityTimelineGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetActivityTimelineAppAccountActionsActivityTimelineGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetActivityTimelineAppAccountActionsActivityTimelineGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/timeline',
    ...options
});

/**
 * Get Accounts Reviewed Timeline
 *
 * Get timeline of new accounts reviewed by the platform.
 *
 * Returns daily counts of new accounts added (via CSV import, competitors widget, etc.)
 * for the specified period.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * days: Number of days to include. None means all time.
 *
 * Returns:
 * AccountsReviewedTimelineResponse with daily account counts.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGet = <ThrowOnError extends boolean = false>(options?: Options<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetData, ThrowOnError>): RequestResult<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponses, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponses, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/accounts-reviewed',
    ...options
});

/**
 * Get Competitors Stats
 *
 * Get stats on competitors identified by the platform.
 *
 * Returns count of competitors identified from agent runs and how many
 * have been added as accounts.
 *
 * Returns:
 * CompetitorsStatsResponse with identified and added counts.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetData, ThrowOnError>): RequestResult<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/competitors-stats',
    ...options
});

/**
 * Get Researching Accounts Count
 *
 * Get count of accounts currently being researched by agents.
 *
 * Returns count of accounts where processing_status is NULL (in-progress or queued).
 *
 * Returns:
 * ResearchingAccountsResponse with count.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getResearchingAccountsCountAppAccountActionsActivityResearchingCountGet = <ThrowOnError extends boolean = false>(options?: Options<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetData, ThrowOnError>): RequestResult<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/researching-count',
    ...options
});

/**
 * Get Activity Log
 *
 * Get paginated activity log for an organization.
 *
 * Returns a paginated list of all user actions with filtering options.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * request: Query parameters for filtering and pagination.
 *
 * Returns:
 * ActivityLogResponse with paginated entries.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getActivityLogAppAccountActionsActivityLogGet = <ThrowOnError extends boolean = false>(options?: Options<GetActivityLogAppAccountActionsActivityLogGetData, ThrowOnError>): RequestResult<GetActivityLogAppAccountActionsActivityLogGetResponses, GetActivityLogAppAccountActionsActivityLogGetErrors, ThrowOnError> => (options?.client ?? client).get<GetActivityLogAppAccountActionsActivityLogGetResponses, GetActivityLogAppAccountActionsActivityLogGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetActivityLogAppAccountActionsActivityLogGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetActivityLogAppAccountActionsActivityLogGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/log',
    ...options
});

/**
 * Report Data Issue
 *
 * Report a data issue for an account.
 *
 * Creates a Plain support thread and logs a UserAction.
 *
 * Returns:
 * Response with success status and optional Plain thread ID.
 *
 * Raises:
 * HTTPException: If account not found (404) or permission denied (403).
 * PlainThreadCreationError: If Plain thread creation fails after retries.
 */
export const reportDataIssue = <ThrowOnError extends boolean = false>(options: Options<ReportDataIssueData, ThrowOnError>): RequestResult<ReportDataIssueResponses, ReportDataIssueErrors, ThrowOnError> => (options.client ?? client).post<ReportDataIssueResponses, ReportDataIssueErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zReportDataIssueBody,
        path: zReportDataIssuePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReportDataIssueResponse2.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/data-issue/{account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Feedback
 *
 * Get the latest feedback for a record.
 *
 * Returns the most recent feedback from any user, or None if no feedback exists.
 *
 * Returns:
 * The latest feedback data for the specified record, or None if not found.
 *
 * Raises:
 * HTTPException: If account not found (404), permission denied (403), or invalid feedback type (400).
 */
export const getFeedback = <ThrowOnError extends boolean = false>(options: Options<GetFeedbackData, ThrowOnError>): RequestResult<GetFeedbackResponses, GetFeedbackErrors, ThrowOnError> => (options.client ?? client).get<GetFeedbackResponses, GetFeedbackErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetFeedbackPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetFeedbackResponse2.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/feedback/{feedback_type}/{record_id}',
    ...options
});

/**
 * Leave Feedback
 *
 * Leave feedback on an account.
 *
 * Creates a new feedback record. Multiple users can leave feedback on the same
 * entity, and the most recent feedback is shown as the "latest".
 *
 * Raises:
 * HTTPException: If account not found (404), permission denied (403), or invalid feedback type (400).
 */
export const leaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPost = <ThrowOnError extends boolean = false>(options: Options<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData, ThrowOnError>): RequestResult<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostResponses, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostErrors, ThrowOnError> => (options.client ?? client).post<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostResponses, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zLeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostBody,
        path: zLeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/feedback/{feedback_type}/{record_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Feedback
 *
 * Delete feedback by ID.
 *
 * Raises:
 * HTTPException: If feedback not found (404) or permission denied (403).
 */
export const deleteFeedback = <ThrowOnError extends boolean = false>(options: Options<DeleteFeedbackData, ThrowOnError>): RequestResult<DeleteFeedbackResponses, DeleteFeedbackErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFeedbackResponses, DeleteFeedbackErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteFeedbackPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/feedback/{feedback_id}',
    ...options
});

/**
 * Generate Email
 *
 * Generate a personalized outreach email using an LLM.
 *
 * Returns:
 * EmailGenerationResponse with subject and body.
 *
 * Raises:
 * HTTPException: If account/user not found, AI unavailable, or AI returns empty response.
 */
export const generateEmailAppAccountActionsEmailGenerationPost = <ThrowOnError extends boolean = false>(options: Options<GenerateEmailAppAccountActionsEmailGenerationPostData, ThrowOnError>): RequestResult<GenerateEmailAppAccountActionsEmailGenerationPostResponses, GenerateEmailAppAccountActionsEmailGenerationPostErrors, ThrowOnError> => (options.client ?? client).post<GenerateEmailAppAccountActionsEmailGenerationPostResponses, GenerateEmailAppAccountActionsEmailGenerationPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGenerateEmailAppAccountActionsEmailGenerationPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGenerateEmailAppAccountActionsEmailGenerationPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/email-generation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Renewal Report
 *
 * Dispatch a renewal-report workflow and tell the client it'll be emailed.
 *
 * Returns:
 * ``RenewalReportQueuedResponse`` echoing the status and the admin's
 * email address, with HTTP 202.
 *
 * Raises:
 * HTTPException: 403 if the caller is not an org admin or has no
 * organization context.
 */
export const exportRenewalReportAppAccountActionsActivityRenewalReportExportPost = <ThrowOnError extends boolean = false>(options: Options<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData, ThrowOnError>): RequestResult<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponses, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostErrors, ThrowOnError> => (options.client ?? client).post<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponses, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExportRenewalReportAppAccountActionsActivityRenewalReportExportPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/account-actions/activity/renewal-report/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Buyer Profiles
 *
 * List all buyer profiles (tags) visible to the user.
 *
 * Returns:
 * - Tags from user's own organization (can be applied/removed)
 * - Tags from other organizations that are applied to shared accounts (read-only)
 *
 * Tags are namespaced by organization. Users can filter by any visible tag
 * but can only create/apply/remove tags belonging to their own organization.
 *
 * Returns:
 * list[BuyerProfileReturn] instance.
 *
 * Raises:
 * HTTPException: If failed to fetch buyer profiles (500).
 */
export const listBuyerProfilesAppBuyerProfilesGet = <ThrowOnError extends boolean = false>(options?: Options<ListBuyerProfilesAppBuyerProfilesGetData, ThrowOnError>): RequestResult<ListBuyerProfilesAppBuyerProfilesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListBuyerProfilesAppBuyerProfilesGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListBuyerProfilesAppBuyerProfilesGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/buyer-profiles',
    ...options
});

/**
 * Create Buyer Profile
 *
 * Create a new buyer profile (tag).
 *
 * Requires profile_name. Automatically associates with user's organization.
 * Returns 409 if a profile with the same name already exists.
 *
 * Returns:
 * BuyerProfileReturn instance.
 *
 * Raises:
 * HTTPException: If tag with same name already exists (409) or failed to create (500).
 */
export const createBuyerProfileAppBuyerProfilesPost = <ThrowOnError extends boolean = false>(options: Options<CreateBuyerProfileAppBuyerProfilesPostData, ThrowOnError>): RequestResult<CreateBuyerProfileAppBuyerProfilesPostResponses, CreateBuyerProfileAppBuyerProfilesPostErrors, ThrowOnError> => (options.client ?? client).post<CreateBuyerProfileAppBuyerProfilesPostResponses, CreateBuyerProfileAppBuyerProfilesPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateBuyerProfileAppBuyerProfilesPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateBuyerProfileAppBuyerProfilesPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/buyer-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Tag Associations
 *
 * Update tag associations for accounts using add/remove semantics.
 *
 * Always uses add/remove mode - only the specified tags are added or removed,
 * other existing tags are preserved.
 *
 * Important: Users can only apply/remove tags belonging to their own organization.
 * Cross-org tags are read-only (visible for filtering but cannot be modified).
 *
 * Supports two ways to specify accounts:
 * 1. Explicit account IDs
 * 2. Filter state (updates all accounts matching filters)
 *
 * Returns:
 * TagAssociationsResponse instance.
 *
 * Raises:
 * HTTPException: If missing account IDs (400), cross-org tags (403),
 * or failed to update associations (500).
 */
export const updateTagAssociationsAppBuyerProfilesAssociationsPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData, ThrowOnError>): RequestResult<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponses, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponses, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateTagAssociationsAppBuyerProfilesAssociationsPatchBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/buyer-profiles/associations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Buyer Profile
 *
 * Delete a buyer profile (tag) and all its account associations.
 *
 * Only tags belonging to the user's organization can be deleted.
 * Associated account-tag links are removed via CASCADE.
 *
 * Returns:
 * Success message.
 *
 * Raises:
 * HTTPException: If tag not found (404), not owned by org (403),
 * or failed to delete (500).
 */
export const deleteBuyerProfileAppBuyerProfilesTagIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData, ThrowOnError>): RequestResult<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponses, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponses, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteBuyerProfileAppBuyerProfilesTagIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/buyer-profiles/{tag_id}',
    ...options
});

/**
 * Update Buyer Profile
 *
 * Update a buyer profile (tag) name or description.
 *
 * Only tags belonging to the user's organization can be updated.
 *
 * Returns:
 * BuyerProfileReturn instance.
 *
 * Raises:
 * HTTPException: If tag not found (404), not owned by org (403),
 * duplicate name (409), or failed to update (500).
 */
export const updateBuyerProfileAppBuyerProfilesTagIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateBuyerProfileAppBuyerProfilesTagIdPatchData, ThrowOnError>): RequestResult<UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponses, UpdateBuyerProfileAppBuyerProfilesTagIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponses, UpdateBuyerProfileAppBuyerProfilesTagIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateBuyerProfileAppBuyerProfilesTagIdPatchBody,
        path: zUpdateBuyerProfileAppBuyerProfilesTagIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateBuyerProfileAppBuyerProfilesTagIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/buyer-profiles/{tag_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Market Research Reports
 *
 * Get all market research reports for the organization.
 *
 * Returns reports ordered by creation date (newest first).
 *
 * Returns:
 * list[MarketResearchReportListItem] instance.
 *
 * Raises:
 * HTTPException: If failed to fetch reports (500).
 */
export const getMarketResearchReportsAppMarketResearchReportsGet = <ThrowOnError extends boolean = false>(options?: Options<GetMarketResearchReportsAppMarketResearchReportsGetData, ThrowOnError>): RequestResult<GetMarketResearchReportsAppMarketResearchReportsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMarketResearchReportsAppMarketResearchReportsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMarketResearchReportsAppMarketResearchReportsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/market-research/reports',
    ...options
});

/**
 * Create Market Research Report
 *
 * Create a new market research report and dispatch AI generation.
 *
 * Returns:
 * MarketResearchReportResponse instance.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If a report with duplicate parameters already exists (409).
 */
export const createMarketResearchReportAppMarketResearchReportsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMarketResearchReportAppMarketResearchReportsPostData, ThrowOnError>): RequestResult<CreateMarketResearchReportAppMarketResearchReportsPostResponses, CreateMarketResearchReportAppMarketResearchReportsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateMarketResearchReportAppMarketResearchReportsPostResponses, CreateMarketResearchReportAppMarketResearchReportsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateMarketResearchReportAppMarketResearchReportsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateMarketResearchReportAppMarketResearchReportsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/market-research/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Market Research Report
 *
 * Delete a market research report.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If report not found (404).
 */
export const deleteMarketResearchReportAppMarketResearchReportsReportIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData, ThrowOnError>): RequestResult<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteResponses, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteResponses, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteMarketResearchReportAppMarketResearchReportsReportIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/market-research/reports/{report_id}',
    ...options
});

/**
 * Get Market Research Report
 *
 * Get a single market research report by ID (includes full_report and sources).
 *
 * Returns:
 * MarketResearchReportResponse instance.
 */
export const getMarketResearchReportAppMarketResearchReportsReportIdGet = <ThrowOnError extends boolean = false>(options: Options<GetMarketResearchReportAppMarketResearchReportsReportIdGetData, ThrowOnError>): RequestResult<GetMarketResearchReportAppMarketResearchReportsReportIdGetResponses, GetMarketResearchReportAppMarketResearchReportsReportIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetMarketResearchReportAppMarketResearchReportsReportIdGetResponses, GetMarketResearchReportAppMarketResearchReportsReportIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetMarketResearchReportAppMarketResearchReportsReportIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMarketResearchReportAppMarketResearchReportsReportIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/market-research/reports/{report_id}',
    ...options
});

/**
 * Regenerate Market Research Report
 *
 * Regenerate an existing market research report.
 *
 * Returns:
 * MarketResearchReportResponse instance.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If the report is not found (404).
 */
export const regenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePost = <ThrowOnError extends boolean = false>(options: Options<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData, ThrowOnError>): RequestResult<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponses, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostErrors, ThrowOnError> => (options.client ?? client).post<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponses, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/market-research/reports/{report_id}/regenerate',
    ...options
});

/**
 * Get Newsfeed
 *
 * Get newsfeed of company events with detailed information.
 *
 * Returns company events with all available data fields for detailed formatting.
 * Supports pagination and date filtering.
 *
 * Returns:
 * Page[NewsfeedItem] instance.
 *
 * Raises:
 * HTTPException: Organization not found
 */
export const getNewsfeedAppInboxNewsfeedGet = <ThrowOnError extends boolean = false>(options?: Options<GetNewsfeedAppInboxNewsfeedGetData, ThrowOnError>): RequestResult<GetNewsfeedAppInboxNewsfeedGetResponses, GetNewsfeedAppInboxNewsfeedGetErrors, ThrowOnError> => (options?.client ?? client).get<GetNewsfeedAppInboxNewsfeedGetResponses, GetNewsfeedAppInboxNewsfeedGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetNewsfeedAppInboxNewsfeedGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetNewsfeedAppInboxNewsfeedGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/newsfeed/',
    ...options
});

/**
 * List Recommendations
 *
 * List action recommendations visible to the current user.
 *
 * Returns:
 * PaginatedRecommendationsResponse sorted by created_at descending.
 */
export const listRecommendationsAppInboxRecommendationsGet = <ThrowOnError extends boolean = false>(options?: Options<ListRecommendationsAppInboxRecommendationsGetData, ThrowOnError>): RequestResult<ListRecommendationsAppInboxRecommendationsGetResponses, ListRecommendationsAppInboxRecommendationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListRecommendationsAppInboxRecommendationsGetResponses, ListRecommendationsAppInboxRecommendationsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListRecommendationsAppInboxRecommendationsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListRecommendationsAppInboxRecommendationsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/',
    ...options
});

/**
 * Get Recommendation Count
 *
 * Get counts of recommendations visible to the current user.
 *
 * Returns:
 * RecommendationCountResponse with pending, actioned, dismissed, unread counts.
 */
export const getRecommendationCountAppInboxRecommendationsCountGet = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendationCountAppInboxRecommendationsCountGetData, ThrowOnError>): RequestResult<GetRecommendationCountAppInboxRecommendationsCountGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRecommendationCountAppInboxRecommendationsCountGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetRecommendationCountAppInboxRecommendationsCountGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/count',
    ...options
});

/**
 * Get Recommendation By Public Id
 *
 * Get a single recommendation by its public UUID.
 *
 * Used for deep-linking from email notifications and shareable URLs.
 * Read-only — does NOT mark as read (frontend calls POST /read separately).
 * Dismissed items return 404, consistent with the list endpoint.
 *
 * Returns:
 * RecommendationResponse for the requested item.
 */
export const getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGet = <ThrowOnError extends boolean = false>(options: Options<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetData, ThrowOnError>): RequestResult<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponses, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponses, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/by-public-id/{public_id}',
    ...options
});

/**
 * Action Recommendation
 *
 * Log outreach and mark a recommendation as actioned.
 *
 * Creates an account note on the first account and transitions the
 * recommendation to ACTIONED status (shared — visible to all users).
 *
 * Returns:
 * Updated RecommendationResponse with ACTIONED status.
 */
export const actionRecommendationAppInboxRecommendationsRecommendationIdActionPost = <ThrowOnError extends boolean = false>(options: Options<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData, ThrowOnError>): RequestResult<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponses, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostErrors, ThrowOnError> => (options.client ?? client).post<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponses, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostBody,
        path: zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dismiss Recommendation
 *
 * Dismiss a recommendation for the current user.
 *
 * Per-user dismissal. When all eligible users have dismissed,
 * the recommendation transitions to shared DISMISSED status so it
 * won't resurface for newly assigned users.
 *
 * Returns:
 * Updated RecommendationResponse with dismissed=True.
 */
export const dismissRecommendationAppInboxRecommendationsRecommendationIdDismissPost = <ThrowOnError extends boolean = false>(options: Options<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData, ThrowOnError>): RequestResult<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponses, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostErrors, ThrowOnError> => (options.client ?? client).post<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponses, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostBody,
        path: zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Read
 *
 * Mark a recommendation as read for the current user.
 *
 * Returns:
 * Updated RecommendationResponse with is_read=True.
 */
export const markReadAppInboxRecommendationsRecommendationIdReadPost = <ThrowOnError extends boolean = false>(options: Options<MarkReadAppInboxRecommendationsRecommendationIdReadPostData, ThrowOnError>): RequestResult<MarkReadAppInboxRecommendationsRecommendationIdReadPostResponses, MarkReadAppInboxRecommendationsRecommendationIdReadPostErrors, ThrowOnError> => (options.client ?? client).post<MarkReadAppInboxRecommendationsRecommendationIdReadPostResponses, MarkReadAppInboxRecommendationsRecommendationIdReadPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zMarkReadAppInboxRecommendationsRecommendationIdReadPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMarkReadAppInboxRecommendationsRecommendationIdReadPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/read',
    ...options
});

/**
 * Mark Unread
 *
 * Mark a recommendation as unread for the current user.
 *
 * Returns:
 * Updated RecommendationResponse with is_read=False.
 */
export const markUnreadAppInboxRecommendationsRecommendationIdUnreadPost = <ThrowOnError extends boolean = false>(options: Options<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData, ThrowOnError>): RequestResult<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponses, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostErrors, ThrowOnError> => (options.client ?? client).post<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponses, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zMarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/unread',
    ...options
});

/**
 * Get Generated Account Ids
 *
 * Get generation status for accounts in a multi-assignment AR.
 *
 * Returns status for accounts that have been interacted with (pending,
 * generated, or failed). Accounts not yet acted on are absent from the result.
 *
 * Status values:
 * - "generated": single-account AR exists; public_id is set
 * - "dismissed": single-account AR exists but was dismissed
 * - "pending": Temporal workflow is running
 * - "failed": Temporal workflow failed
 *
 * Returns:
 * Mapping of account ID (as string) to GeneratedAccountStatus.
 *
 * Raises:
 * HTTPException: 404 if parent recommendation not found.
 */
export const getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGet = <ThrowOnError extends boolean = false>(options: Options<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetData, ThrowOnError>): RequestResult<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponses, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetErrors, ThrowOnError> => (options.client ?? client).get<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponses, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/generated-account-ids',
    ...options
});

/**
 * Generate Account Ar
 *
 * Generate a single-account AR with LLM insights from a multi-assignment.
 *
 * Creates a new ASSIGNMENT inbox item for the specified account with
 * AI-generated summary and suggested next steps. The generated AR is
 * only visible to the requesting user.
 *
 * Returns:
 * GenerateAccountARResponse with status "started", "already_exists",
 * or "already_running".
 *
 * Error responses:
 * 404 if parent recommendation not found.
 * 400 if account_id is not in the parent's account_ids, or the parent is
 * not a multi-account assignment.
 */
export const generateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPost = <ThrowOnError extends boolean = false>(options: Options<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData, ThrowOnError>): RequestResult<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponses, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostErrors, ThrowOnError> => (options.client ?? client).post<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponses, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostBody,
        path: zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/generate-account-ar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Share Recommendation
 *
 * Forward the inbox item's stored payload to chosen recipients.
 *
 * Reads ``manual_share`` config from ``AR_NOTIFICATION_REGISTRY``: the AR
 * type's email_type, role gate, and template_data key all come from there.
 * Any AR type that opts into manual_share gets this endpoint for free.
 *
 * Returns:
 * EmailShareResponse with the number of recipients the email reached.
 *
 * Error responses:
 * 404 if the AR is missing or its type does not expose manual_share,
 * or the caller isn't on the AR's user_ids list.
 * 403 if the caller's role is below ``manual_share.required_role``.
 * 400 if the AR has no rendered template_data, or recipients are invalid.
 */
export const emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPost = <ThrowOnError extends boolean = false>(options: Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData, ThrowOnError>): RequestResult<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostErrors, ThrowOnError> => (options.client ?? client).post<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostBody,
        path: zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/email-renewal-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Share Recommendation
 *
 * Forward the inbox item's stored payload to chosen recipients.
 *
 * Reads ``manual_share`` config from ``AR_NOTIFICATION_REGISTRY``: the AR
 * type's email_type, role gate, and template_data key all come from there.
 * Any AR type that opts into manual_share gets this endpoint for free.
 *
 * Returns:
 * EmailShareResponse with the number of recipients the email reached.
 *
 * Error responses:
 * 404 if the AR is missing or its type does not expose manual_share,
 * or the caller isn't on the AR's user_ids list.
 * 403 if the caller's role is below ``manual_share.required_role``.
 * 400 if the AR has no rendered template_data, or recipients are invalid.
 */
export const emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePost = <ThrowOnError extends boolean = false>(options: Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData, ThrowOnError>): RequestResult<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostErrors, ThrowOnError> => (options.client ?? client).post<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponses, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostBody,
        path: zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/inbox/recommendations/{recommendation_id}/email-share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chat Auth
 *
 * Authenticate a user for the Plain chat.
 *
 * Returns:
 * ChatAuthResponse with available=True and auth details if configured,
 * or available=False with null fields if not configured (in non-prod).
 *
 * Raises:
 * HTTPException: 500 if Plain chat secret not configured in staging/production.
 */
export const chatAuthAppChatAuthGet = <ThrowOnError extends boolean = false>(options?: Options<ChatAuthAppChatAuthGetData, ThrowOnError>): RequestResult<ChatAuthAppChatAuthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ChatAuthAppChatAuthGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zChatAuthAppChatAuthGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/chat-auth/',
    ...options
});

/**
 * Transcribe Debrief
 *
 * Transcribe audio and extract meeting debrief fields.
 *
 * Returns:
 * Transcript text and AI-extracted debrief fields.
 */
export const transcribeDebriefAppDebriefTranscribePost = <ThrowOnError extends boolean = false>(options: Options<TranscribeDebriefAppDebriefTranscribePostData, ThrowOnError>): RequestResult<TranscribeDebriefAppDebriefTranscribePostResponses, TranscribeDebriefAppDebriefTranscribePostErrors, ThrowOnError> => (options.client ?? client).post<TranscribeDebriefAppDebriefTranscribePostResponses, TranscribeDebriefAppDebriefTranscribePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zTranscribeDebriefAppDebriefTranscribePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTranscribeDebriefAppDebriefTranscribePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/transcribe',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Save Debrief
 *
 * Save a completed debrief.
 *
 * Returns:
 * The saved debrief as a history item.
 */
export const saveDebriefAppDebriefSavePost = <ThrowOnError extends boolean = false>(options: Options<SaveDebriefAppDebriefSavePostData, ThrowOnError>): RequestResult<SaveDebriefAppDebriefSavePostResponses, SaveDebriefAppDebriefSavePostErrors, ThrowOnError> => (options.client ?? client).post<SaveDebriefAppDebriefSavePostResponses, SaveDebriefAppDebriefSavePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zSaveDebriefAppDebriefSavePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveDebriefAppDebriefSavePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Debrief History
 *
 * List past debriefs for the current user's organization, newest first.
 *
 * Returns:
 * Paginated list of debrief history items.
 */
export const getDebriefHistoryAppDebriefHistoryGet = <ThrowOnError extends boolean = false>(options?: Options<GetDebriefHistoryAppDebriefHistoryGetData, ThrowOnError>): RequestResult<GetDebriefHistoryAppDebriefHistoryGetResponses, GetDebriefHistoryAppDebriefHistoryGetErrors, ThrowOnError> => (options?.client ?? client).get<GetDebriefHistoryAppDebriefHistoryGetResponses, GetDebriefHistoryAppDebriefHistoryGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetDebriefHistoryAppDebriefHistoryGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetDebriefHistoryAppDebriefHistoryGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/history',
    ...options
});

/**
 * Start New Debrief Conversation
 *
 * Create a pending debrief and start a Scout voice conversation in one step.
 *
 * Returns:
 * Debrief ID, signed WebSocket URL, agent ID, and dynamic variables.
 */
export const startNewDebriefConversationAppDebriefConversationStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartNewDebriefConversationAppDebriefConversationStartPostData, ThrowOnError>): RequestResult<StartNewDebriefConversationAppDebriefConversationStartPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<StartNewDebriefConversationAppDebriefConversationStartPostResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartNewDebriefConversationAppDebriefConversationStartPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/conversation/start',
    ...options
});

/**
 * Start Debrief Conversation
 *
 * Generate a signed URL to start a Scout voice conversation for an existing debrief.
 *
 * Kept for backward compatibility with the old flow.
 *
 * Returns:
 * Signed WebSocket URL, agent ID, and dynamic variables for the mobile SDK.
 *
 * Raises:
 * HTTPException: If debrief not found or not owned by user's org.
 */
export const startDebriefConversationAppDebriefDebriefIdConversationStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDebriefConversationAppDebriefDebriefIdConversationStartPostData, ThrowOnError>): RequestResult<StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponses, StartDebriefConversationAppDebriefDebriefIdConversationStartPostErrors, ThrowOnError> => (options.client ?? client).post<StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponses, StartDebriefConversationAppDebriefDebriefIdConversationStartPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zStartDebriefConversationAppDebriefDebriefIdConversationStartPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartDebriefConversationAppDebriefDebriefIdConversationStartPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/{debrief_id}/conversation/start',
    ...options
});

/**
 * Complete Debrief Conversation
 *
 * Store conversation transcript and send summary email.
 *
 * Called by the mobile app when the Scout conversation ends.
 *
 * Raises:
 * HTTPException: If debrief not found or not owned by user's org.
 */
export const completeDebriefConversationAppDebriefDebriefIdConversationCompletePost = <ThrowOnError extends boolean = false>(options: Options<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData, ThrowOnError>): RequestResult<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponses, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostErrors, ThrowOnError> => (options.client ?? client).post<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponses, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostBody,
        path: zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/debrief/{debrief_id}/conversation/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Debrief Conversation Webhook
 *
 * Webhook endpoint for ElevenLabs server tool to complete a conversation.
 *
 * Authenticates via shared secret in the Authorization Bearer header.
 *
 * Raises:
 * HTTPException: If debrief not found or webhook secret invalid.
 */
export const completeDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPost = <ThrowOnError extends boolean = false>(options: Options<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData, ThrowOnError>): RequestResult<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponses, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostErrors, ThrowOnError> => (options.client ?? client).post<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponses, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostBody,
        headers: zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostHeaders.optional(),
        path: zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponse.parseAsync(data),
    url: '/app/debrief/{debrief_id}/conversation/complete/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Merge Link Token
 *
 * Create a Merge link token for the current user.
 *
 * Returns:
 * MergeLinkTokenResponse containing the link token.
 *
 * Raises:
 * HTTPException: 403 if the organization cannot use integrations.
 * HTTPException: 500 if Merge API key not configured or API call fails.
 */
export const createMergeLinkTokenAppIntegrationsMergeLinkTokenPost = <ThrowOnError extends boolean = false>(options: Options<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData, ThrowOnError>): RequestResult<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponses, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostErrors, ThrowOnError> => (options.client ?? client).post<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponses, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/link-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange Token
 *
 * Exchange a public token for an account token and store the integration.
 *
 * Args:
 * body: Request containing the public_token from Merge Link.
 * session: Database session.
 * current_user: Authenticated user.
 * merge_api_key: Validated Merge API key (injected by dependency).
 *
 * Returns:
 * ExchangeTokenResponse with the created integration ID.
 *
 * Raises:
 * HTTPException: 403 if the organization cannot use integrations.
 * HTTPException: 500 if Merge API key not configured or API call fails.
 */
export const exchangeTokenAppIntegrationsMergeExchangeTokenPost = <ThrowOnError extends boolean = false>(options: Options<ExchangeTokenAppIntegrationsMergeExchangeTokenPostData, ThrowOnError>): RequestResult<ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponses, ExchangeTokenAppIntegrationsMergeExchangeTokenPostErrors, ThrowOnError> => (options.client ?? client).post<ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponses, ExchangeTokenAppIntegrationsMergeExchangeTokenPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExchangeTokenAppIntegrationsMergeExchangeTokenPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zExchangeTokenAppIntegrationsMergeExchangeTokenPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/exchange-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Integration Status
 *
 * Get the current CRM integration status for the organization.
 *
 * Returns:
 * IntegrationStatusResponse with connection status and integration details.
 */
export const getIntegrationStatusAppIntegrationsMergeStatusGet = <ThrowOnError extends boolean = false>(options?: Options<GetIntegrationStatusAppIntegrationsMergeStatusGetData, ThrowOnError>): RequestResult<GetIntegrationStatusAppIntegrationsMergeStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetIntegrationStatusAppIntegrationsMergeStatusGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetIntegrationStatusAppIntegrationsMergeStatusGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/status',
    ...options
});

/**
 * Sync Merge Accounts
 *
 * Start a Temporal workflow to sync accounts from the connected CRM.
 *
 * Args:
 * body: Request containing the integration_id to sync.
 * session: Database session.
 * current_user: Authenticated user.
 * temporal: Temporal client.
 * permissions_service: Permission checker.
 *
 * Returns:
 * SyncResponse with workflow ID and status message.
 *
 * Raises:
 * HTTPException: 404 if integration not found.
 */
export const syncMergeAccountsAppIntegrationsMergeSyncPost = <ThrowOnError extends boolean = false>(options: Options<SyncMergeAccountsAppIntegrationsMergeSyncPostData, ThrowOnError>): RequestResult<SyncMergeAccountsAppIntegrationsMergeSyncPostResponses, SyncMergeAccountsAppIntegrationsMergeSyncPostErrors, ThrowOnError> => (options.client ?? client).post<SyncMergeAccountsAppIntegrationsMergeSyncPostResponses, SyncMergeAccountsAppIntegrationsMergeSyncPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zSyncMergeAccountsAppIntegrationsMergeSyncPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSyncMergeAccountsAppIntegrationsMergeSyncPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Failed Accounts Csv
 *
 * Download failed accounts from a sync log as CSV.
 *
 * Args:
 * log_id: The ID of the sync log to download.
 * session: Database session.
 * current_user: Authenticated user.
 *
 * Returns:
 * StreamingResponse with CSV content.
 *
 * Raises:
 * HTTPException: 404 if log not found or doesn't belong to this org.
 */
export const downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGet = <ThrowOnError extends boolean = false>(options: Options<DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetData, ThrowOnError>): RequestResult<DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetResponses, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetResponses, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/logs/{log_id}/failed-accounts.csv',
    ...options
});

/**
 * Get Crm Users
 *
 * Get CRM users for the organization with their matched SUPPLYCO users.
 *
 * Returns:
 * CrmUsersResponse with list of CRM users and their matches.
 */
export const getCrmUsersAppIntegrationsMergeCrmUsersGet = <ThrowOnError extends boolean = false>(options?: Options<GetCrmUsersAppIntegrationsMergeCrmUsersGetData, ThrowOnError>): RequestResult<GetCrmUsersAppIntegrationsMergeCrmUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCrmUsersAppIntegrationsMergeCrmUsersGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCrmUsersAppIntegrationsMergeCrmUsersGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/integrations/merge/crm-users',
    ...options
});

/**
 * Enrich By Linkedin Url
 *
 * Look up contact details for a LinkedIn profile URL.
 *
 * First searches the database by LinkedIn URL. If no enriched result is found,
 * falls back to Explorium's match_prospects endpoint to resolve the prospect ID
 * and looks up the enriched record by prospect ID. When the profile is unknown
 * to the DB but Explorium resolves a prospect_id, a skeleton ExploriumPerson
 * is created and enriched on the fly (same fields the web app's "Get Contact
 * Details" button populates).
 *
 * Returns 404 only when both the DB and Explorium have no match for the URL.
 *
 * Returns:
 * LinkedInContactDetails with available contact data.
 *
 * Raises:
 * HTTPException: 422 if URL is not a valid LinkedIn profile URL.
 * HTTPException: 404 if neither the DB nor Explorium can match the URL.
 */
export const enrichByLinkedinUrlAppLinkedinEnrichPost = <ThrowOnError extends boolean = false>(options: Options<EnrichByLinkedinUrlAppLinkedinEnrichPostData, ThrowOnError>): RequestResult<EnrichByLinkedinUrlAppLinkedinEnrichPostResponses, EnrichByLinkedinUrlAppLinkedinEnrichPostErrors, ThrowOnError> => (options.client ?? client).post<EnrichByLinkedinUrlAppLinkedinEnrichPostResponses, EnrichByLinkedinUrlAppLinkedinEnrichPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zEnrichByLinkedinUrlAppLinkedinEnrichPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEnrichByLinkedinUrlAppLinkedinEnrichPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/linkedin/enrich',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim Leads
 *
 * Claim all pre-generated scout leads for the current org.
 *
 * Flips lead_status from PRE_GENERATED to None, making leads appear
 * directly in the accounts list.
 *
 * Returns:
 * ClaimLeadsResponse with claimed count and items.
 *
 * Raises:
 * HTTPException: 403 if user lacks scout leads permission.
 */
export const claimLeadsAppScoutClaimPost = <ThrowOnError extends boolean = false>(options?: Options<ClaimLeadsAppScoutClaimPostData, ThrowOnError>): RequestResult<ClaimLeadsAppScoutClaimPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ClaimLeadsAppScoutClaimPostResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zClaimLeadsAppScoutClaimPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/scout/claim',
    ...options
});

/**
 * Get Dashboard
 *
 * Get scout dashboard stats.
 *
 * Returns:
 * Pre-generated lead count and latest run summary.
 *
 * Raises:
 * HTTPException: 403 if user lacks scout leads permission.
 */
export const getDashboardAppScoutDashboardGet = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardAppScoutDashboardGetData, ThrowOnError>): RequestResult<GetDashboardAppScoutDashboardGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDashboardAppScoutDashboardGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetDashboardAppScoutDashboardGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/scout/dashboard',
    ...options
});

/**
 * Parse Territory
 *
 * Parse free-text territory input into structured region list.
 *
 * Tries a fast dict-based lookup first (handles exact names, region groups,
 * and whole-country aliases). Falls back to an LLM call for fuzzier input
 * like "pacific northwest" or "all of North America" — the LLM is constrained
 * to return names from our known taxonomy, so output is always grounded.
 *
 * Returns:
 * TerritoryParseResponse with matched regions (may be empty if nothing
 * in the taxonomy matches the user's text).
 */
export const parseTerritoryAppOnboardingParseTerritoryPost = <ThrowOnError extends boolean = false>(options: Options<ParseTerritoryAppOnboardingParseTerritoryPostData, ThrowOnError>): RequestResult<ParseTerritoryAppOnboardingParseTerritoryPostResponses, ParseTerritoryAppOnboardingParseTerritoryPostErrors, ThrowOnError> => (options.client ?? client).post<ParseTerritoryAppOnboardingParseTerritoryPostResponses, ParseTerritoryAppOnboardingParseTerritoryPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zParseTerritoryAppOnboardingParseTerritoryPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zParseTerritoryAppOnboardingParseTerritoryPostResponse.parseAsync(data),
    url: '/app/onboarding/parse-territory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Partners
 *
 * Return the curated partner directory for onboarding.
 *
 * Backed by a static JSON file shipped with the app. Grows when the file
 * grows; no DB queries.
 *
 * Returns:
 * List of partner directory entries, sorted by name.
 */
export const getPartnersAppOnboardingPartnersGet = <ThrowOnError extends boolean = false>(options?: Options<GetPartnersAppOnboardingPartnersGetData, ThrowOnError>): RequestResult<GetPartnersAppOnboardingPartnersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPartnersAppOnboardingPartnersGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPartnersAppOnboardingPartnersGetResponse.parseAsync(data),
    url: '/app/onboarding/partners',
    ...options
});

/**
 * Onboarding Complete
 *
 * Submit onboarding form and send verification email.
 *
 * Returns:
 * OnboardingCompleteResponse with status "sent".
 *
 * Raises:
 * HTTPException: If email domain is a personal email provider.
 */
export const onboardingCompleteAppOnboardingCompletePost = <ThrowOnError extends boolean = false>(options: Options<OnboardingCompleteAppOnboardingCompletePostData, ThrowOnError>): RequestResult<OnboardingCompleteAppOnboardingCompletePostResponses, OnboardingCompleteAppOnboardingCompletePostErrors, ThrowOnError> => (options.client ?? client).post<OnboardingCompleteAppOnboardingCompletePostResponses, OnboardingCompleteAppOnboardingCompletePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zOnboardingCompleteAppOnboardingCompletePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zOnboardingCompleteAppOnboardingCompletePostResponse.parseAsync(data),
    url: '/app/onboarding/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Onboarding Activate
 *
 * Verify email token, create org + user, redirect with exchange token.
 *
 * The exchange token is short-lived and redeemed by the frontend via
 * POST /exchange-token, which sets the auth cookie through the standard
 * CookieTransport (avoiding cross-domain cookie issues).
 *
 * Returns:
 * RedirectResponse to activated page with exchange token or error.
 */
export const onboardingActivateAppOnboardingActivateGet = <ThrowOnError extends boolean = false>(options: Options<OnboardingActivateAppOnboardingActivateGetData, ThrowOnError>): RequestResult<OnboardingActivateAppOnboardingActivateGetResponses, OnboardingActivateAppOnboardingActivateGetErrors, ThrowOnError> => (options.client ?? client).get<OnboardingActivateAppOnboardingActivateGetResponses, OnboardingActivateAppOnboardingActivateGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zOnboardingActivateAppOnboardingActivateGetQuery
    }).parseAsync(data),
    url: '/app/onboarding/activate',
    ...options
});

/**
 * Onboarding Exchange Token
 *
 * Exchange a short-lived onboarding token for an auth cookie.
 *
 * Uses the same CookieTransport as the rest of the auth system,
 * so cookie domain/secure/samesite are handled consistently.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If the exchange token is invalid or expired.
 */
export const onboardingExchangeTokenAppOnboardingExchangeTokenPost = <ThrowOnError extends boolean = false>(options: Options<OnboardingExchangeTokenAppOnboardingExchangeTokenPostData, ThrowOnError>): RequestResult<OnboardingExchangeTokenAppOnboardingExchangeTokenPostResponses, OnboardingExchangeTokenAppOnboardingExchangeTokenPostErrors, ThrowOnError> => (options.client ?? client).post<OnboardingExchangeTokenAppOnboardingExchangeTokenPostResponses, OnboardingExchangeTokenAppOnboardingExchangeTokenPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zOnboardingExchangeTokenAppOnboardingExchangeTokenPostQuery
    }).parseAsync(data),
    url: '/app/onboarding/exchange-token',
    ...options
});

/**
 * Join Info
 *
 * Decode invite JWT and return hydration payload for member onboarding.
 *
 * Does NOT consume the token — that happens at join-complete.
 *
 * Returns:
 * JoinInfoResponse with email, org name, and company territory.
 *
 * Raises:
 * HTTPException: If token is invalid or user is already verified.
 */
export const joinInfoAppOnboardingJoinInfoGet = <ThrowOnError extends boolean = false>(options: Options<JoinInfoAppOnboardingJoinInfoGetData, ThrowOnError>): RequestResult<JoinInfoAppOnboardingJoinInfoGetResponses, JoinInfoAppOnboardingJoinInfoGetErrors, ThrowOnError> => (options.client ?? client).get<JoinInfoAppOnboardingJoinInfoGetResponses, JoinInfoAppOnboardingJoinInfoGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zJoinInfoAppOnboardingJoinInfoGetQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zJoinInfoAppOnboardingJoinInfoGetResponse.parseAsync(data),
    url: '/app/onboarding/join-info',
    ...options
});

/**
 * Join Complete
 *
 * Set password, store name + territory, mark verified, return auth cookie.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If token is invalid or user is already verified.
 */
export const joinCompleteAppOnboardingJoinCompletePost = <ThrowOnError extends boolean = false>(options: Options<JoinCompleteAppOnboardingJoinCompletePostData, ThrowOnError>): RequestResult<JoinCompleteAppOnboardingJoinCompletePostResponses, JoinCompleteAppOnboardingJoinCompletePostErrors, ThrowOnError> => (options.client ?? client).post<JoinCompleteAppOnboardingJoinCompletePostResponses, JoinCompleteAppOnboardingJoinCompletePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zJoinCompleteAppOnboardingJoinCompletePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/app/onboarding/join-complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partner Invite Create
 *
 * Create a partner invite and send the invitation email.
 *
 * Returns:
 * PartnerInviteCreateResponse with invite details.
 *
 * Raises:
 * HTTPException: 403 if the actor is not in an organization.
 */
export const partnerInviteCreateAppOnboardingPartnerInviteCreatePost = <ThrowOnError extends boolean = false>(options: Options<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData, ThrowOnError>): RequestResult<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponses, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostErrors, ThrowOnError> => (options.client ?? client).post<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponses, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zPartnerInviteCreateAppOnboardingPartnerInviteCreatePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/onboarding/partner-invite/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partner Invite Info
 *
 * Return context for a partner invite link (unauthenticated).
 *
 * Returns:
 * PartnerInviteInfoResponse with invite details.
 */
export const partnerInviteInfoAppOnboardingPartnerInviteInfoGet = <ThrowOnError extends boolean = false>(options: Options<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetData, ThrowOnError>): RequestResult<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponses, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetErrors, ThrowOnError> => (options.client ?? client).get<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponses, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zPartnerInviteInfoAppOnboardingPartnerInviteInfoGetQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zPartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponse.parseAsync(data),
    url: '/app/onboarding/partner-invite/info',
    ...options
});

/**
 * Demoday Signup
 *
 * Sign a prospect (and optionally their teammates) up at the conference.
 *
 * Returns:
 * ``Response`` with a ``Set-Cookie`` header from the auth backend and a
 * JSON body of ``{firstName, organizationName, emailsSent}`` — no
 * plaintext passwords. Every created user receives a DEMODAY_INVITE
 * email with a single-use set-password link.
 */
export const demodaySignupAppDemodaySignupPost = <ThrowOnError extends boolean = false>(options: Options<DemodaySignupAppDemodaySignupPostData, ThrowOnError>): RequestResult<DemodaySignupAppDemodaySignupPostResponses, DemodaySignupAppDemodaySignupPostErrors, ThrowOnError> => (options.client ?? client).post<DemodaySignupAppDemodaySignupPostResponses, DemodaySignupAppDemodaySignupPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zDemodaySignupAppDemodaySignupPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDemodaySignupAppDemodaySignupPostResponse.parseAsync(data),
    url: '/app/demoday/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Demoday Orgs
 *
 * Return demoday-tagged orgs sorted by name.
 *
 * Returns:
 * Sorted list of ``DemoDayOrgEntry`` items for all orgs with a
 * ``demoday_event`` key in ``onboarding_data``.
 */
export const listDemodayOrgsAppDemodayOrgsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDemodayOrgsAppDemodayOrgsGetData, ThrowOnError>): RequestResult<ListDemodayOrgsAppDemodayOrgsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDemodayOrgsAppDemodayOrgsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListDemodayOrgsAppDemodayOrgsGetResponse.parseAsync(data),
    url: '/app/demoday/orgs',
    ...options
});

/**
 * Join
 *
 * Add primary + teammates to a pre-baked demoday org and log in primary.
 *
 * Returns:
 * ``Response`` with a ``Set-Cookie`` header from the auth backend and a
 * JSON body of ``{firstName, organizationName, emailsSent}``.
 */
export const joinAppDemodayJoinPost = <ThrowOnError extends boolean = false>(options: Options<JoinAppDemodayJoinPostData, ThrowOnError>): RequestResult<JoinAppDemodayJoinPostResponses, JoinAppDemodayJoinPostErrors, ThrowOnError> => (options.client ?? client).post<JoinAppDemodayJoinPostResponses, JoinAppDemodayJoinPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zJoinAppDemodayJoinPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zJoinAppDemodayJoinPostResponse.parseAsync(data),
    url: '/app/demoday/join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Deals
 *
 * Paginated deals belonging to the auth'd org.
 *
 * Returns:
 * A page of ``DealListItem`` rows with rollup fields (document count,
 * last-event kind, allowed onward transitions).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listDealsAppOrdersDealsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDealsAppOrdersDealsGetData, ThrowOnError>): RequestResult<ListDealsAppOrdersDealsGetResponses, ListDealsAppOrdersDealsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListDealsAppOrdersDealsGetResponses, ListDealsAppOrdersDealsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListDealsAppOrdersDealsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListDealsAppOrdersDealsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/deals',
    ...options
});

/**
 * Transition Deal Stage
 *
 * Move a deal to a new stage and write an audit row.
 *
 * Returns:
 * The updated stage + the new allowed transitions, so the frontend
 * can refresh the popover without a list re-fetch.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the deal
 * doesn't exist or belongs to a different org, 422 if the requested
 * transition is not in the allowed set for the deal's current stage.
 */
export const transitionDealStageAppOrdersDealsDealIdStagePost = <ThrowOnError extends boolean = false>(options: Options<TransitionDealStageAppOrdersDealsDealIdStagePostData, ThrowOnError>): RequestResult<TransitionDealStageAppOrdersDealsDealIdStagePostResponses, TransitionDealStageAppOrdersDealsDealIdStagePostErrors, ThrowOnError> => (options.client ?? client).post<TransitionDealStageAppOrdersDealsDealIdStagePostResponses, TransitionDealStageAppOrdersDealsDealIdStagePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zTransitionDealStageAppOrdersDealsDealIdStagePostBody,
        path: zTransitionDealStageAppOrdersDealsDealIdStagePostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTransitionDealStageAppOrdersDealsDealIdStagePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/deals/{deal_id}/stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Deal Events
 *
 * Return the deal's hero summary + chronological event timeline.
 *
 * Returns:
 * ``DealEventsResponse`` with the detail block (everything the
 * right-column hero needs) plus a newest-first list of derived
 * events (RFQ_IN, PO_IN, EMAIL_IN/OUT, STAGE_CHANGE, ERROR).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the
 * deal does not exist or belongs to a different org.
 */
export const getDealEventsAppOrdersDealsDealIdEventsGet = <ThrowOnError extends boolean = false>(options: Options<GetDealEventsAppOrdersDealsDealIdEventsGetData, ThrowOnError>): RequestResult<GetDealEventsAppOrdersDealsDealIdEventsGetResponses, GetDealEventsAppOrdersDealsDealIdEventsGetErrors, ThrowOnError> => (options.client ?? client).get<GetDealEventsAppOrdersDealsDealIdEventsGetResponses, GetDealEventsAppOrdersDealsDealIdEventsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetDealEventsAppOrdersDealsDealIdEventsGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetDealEventsAppOrdersDealsDealIdEventsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/deals/{deal_id}/events',
    ...options
});

/**
 * Delete Orders
 *
 * Soft-delete one or more orders by public UUID.
 *
 * Sets ``deleted_at`` and ``deleted_by`` on each row. Soft-deleted orders
 * are filtered out of every read via ``Order.active()`` and become invisible
 * to the API. The underlying inbound message stays as an audit record.
 *
 * Bulk requests are partial-success: unknown, cross-org, or already-deleted
 * ids are reported in ``skipped_ids`` rather than failing the whole request.
 *
 * Returns:
 * Deleted order summaries and skipped ids.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const deleteOrdersAppOrdersDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteOrdersAppOrdersDeleteData, ThrowOnError>): RequestResult<DeleteOrdersAppOrdersDeleteResponses, DeleteOrdersAppOrdersDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrdersAppOrdersDeleteResponses, DeleteOrdersAppOrdersDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zDeleteOrdersAppOrdersDeleteBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteOrdersAppOrdersDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Orders
 *
 * List orders for the current organization.
 *
 * Returns:
 * Paginated list of orders with total count.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listOrdersAppOrdersGet = <ThrowOnError extends boolean = false>(options?: Options<ListOrdersAppOrdersGetData, ThrowOnError>): RequestResult<ListOrdersAppOrdersGetResponses, ListOrdersAppOrdersGetErrors, ThrowOnError> => (options?.client ?? client).get<ListOrdersAppOrdersGetResponses, ListOrdersAppOrdersGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListOrdersAppOrdersGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListOrdersAppOrdersGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders',
    ...options
});

/**
 * Order Stats
 *
 * Return bucket counts for the stats cards.
 *
 * Returns:
 * Total, pending, and errors counts for the current organization.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const orderStatsAppOrdersStatsGet = <ThrowOnError extends boolean = false>(options?: Options<OrderStatsAppOrdersStatsGetData, ThrowOnError>): RequestResult<OrderStatsAppOrdersStatsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrderStatsAppOrdersStatsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zOrderStatsAppOrdersStatsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/stats',
    ...options
});

/**
 * Get Inbound Address
 *
 * Return the per-org inbound forwarding address.
 *
 * Composed from ``Organizations.inbound_email_slug`` and the global
 * ``settings.services.inbound_email_domain``. Resend's wildcard inbound
 * on that domain forwards every local-part to our webhook.
 *
 * Returns:
 * The inbound forwarding email address for the caller's org.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const getInboundAddressAppOrdersInboundAddressGet = <ThrowOnError extends boolean = false>(options?: Options<GetInboundAddressAppOrdersInboundAddressGetData, ThrowOnError>): RequestResult<GetInboundAddressAppOrdersInboundAddressGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInboundAddressAppOrdersInboundAddressGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetInboundAddressAppOrdersInboundAddressGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/inbound-address',
    ...options
});

/**
 * Retry Order
 *
 * Requeue an errored order's original inbound email for extraction.
 *
 * Returns:
 * The order id and Temporal workflow id for the retry run.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the order is not
 * visible to the caller, 409 if the order is not in ERROR.
 */
export const retryOrderAppOrdersOrderIdRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryOrderAppOrdersOrderIdRetryPostData, ThrowOnError>): RequestResult<RetryOrderAppOrdersOrderIdRetryPostResponses, RetryOrderAppOrdersOrderIdRetryPostErrors, ThrowOnError> => (options.client ?? client).post<RetryOrderAppOrdersOrderIdRetryPostResponses, RetryOrderAppOrdersOrderIdRetryPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryOrderAppOrdersOrderIdRetryPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryOrderAppOrdersOrderIdRetryPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/retry',
    ...options
});

/**
 * Reprocess Order
 *
 * Force the full extraction workflow to run again, overwriting all data.
 *
 * Unlike ``retry_order`` (which only accepts ERROR orders), this endpoint
 * accepts an order in any status and resets it so the Temporal workflow's
 * idempotency guard (see ``_is_terminal_ready_order``) will re-run every
 * activity and overwrite the extracted fields and line items.
 *
 * Returns:
 * The order id and Temporal workflow id for the reprocess run.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the order is not
 * visible to the caller.
 */
export const reprocessOrderAppOrdersOrderIdReprocessPost = <ThrowOnError extends boolean = false>(options: Options<ReprocessOrderAppOrdersOrderIdReprocessPostData, ThrowOnError>): RequestResult<ReprocessOrderAppOrdersOrderIdReprocessPostResponses, ReprocessOrderAppOrdersOrderIdReprocessPostErrors, ThrowOnError> => (options.client ?? client).post<ReprocessOrderAppOrdersOrderIdReprocessPostResponses, ReprocessOrderAppOrdersOrderIdReprocessPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zReprocessOrderAppOrdersOrderIdReprocessPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReprocessOrderAppOrdersOrderIdReprocessPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/reprocess',
    ...options
});

/**
 * Get Order
 *
 * Return the detailed view of a single order.
 *
 * ``order_id`` is the public ``Order.public_id`` UUID — URLs never expose
 * the integer PK.
 *
 * Returns:
 * The full order detail, including the originating email body, line
 * items, and short-lived signed URLs for any stored attachments.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the order
 * does not exist or belongs to a different org, 500 if the order is
 * missing its ingestion record.
 */
export const getOrderAppOrdersOrderIdGet = <ThrowOnError extends boolean = false>(options: Options<GetOrderAppOrdersOrderIdGetData, ThrowOnError>): RequestResult<GetOrderAppOrdersOrderIdGetResponses, GetOrderAppOrdersOrderIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrderAppOrdersOrderIdGetResponses, GetOrderAppOrdersOrderIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrderAppOrdersOrderIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOrderAppOrdersOrderIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}',
    ...options
});

/**
 * Update Order
 *
 * Apply a sparse manual edit to an order and its line items.
 *
 * Only fields present in the JSON payload are mutated. Explicit ``null``
 * clears nullable columns; omitted fields are left untouched.
 *
 * Returns:
 * The updated order detail response.
 */
export const updateOrderAppOrdersOrderIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderAppOrdersOrderIdPatchData, ThrowOnError>): RequestResult<UpdateOrderAppOrdersOrderIdPatchResponses, UpdateOrderAppOrdersOrderIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrderAppOrdersOrderIdPatchResponses, UpdateOrderAppOrdersOrderIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateOrderAppOrdersOrderIdPatchBody,
        path: zUpdateOrderAppOrdersOrderIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateOrderAppOrdersOrderIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Order Preview
 *
 * Serve the first-page preview image for an order's attached document.
 *
 * Returns:
 * 200 with the PNG bytes (filesystem backend) or JSON containing a
 * presigned S3 URL (s3 backend).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the order
 * does not exist, belongs to a different org, or has no preview.
 */
export const getOrderPreviewAppOrdersOrderIdPreviewGet = <ThrowOnError extends boolean = false>(options: Options<GetOrderPreviewAppOrdersOrderIdPreviewGetData, ThrowOnError>): RequestResult<GetOrderPreviewAppOrdersOrderIdPreviewGetResponses, GetOrderPreviewAppOrdersOrderIdPreviewGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrderPreviewAppOrdersOrderIdPreviewGetResponses, GetOrderPreviewAppOrdersOrderIdPreviewGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrderPreviewAppOrdersOrderIdPreviewGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/preview',
    ...options
});

/**
 * Get Order Attachment
 *
 * Serve the nth attachment from an order's originating email.
 *
 * Returns:
 * 200 with the file bytes (filesystem backend) or JSON containing a
 * presigned S3 URL (s3 backend).
 */
export const getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGet = <ThrowOnError extends boolean = false>(options: Options<GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetData, ThrowOnError>): RequestResult<GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetResponses, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetResponses, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/attachments/{attachment_index}',
    ...options
});

/**
 * Get Order Attachment Page
 *
 * Render a single page of a PDF attachment as a PNG and stream it.
 *
 * PDF.js (the browser-side renderer) silently drops embedded images on
 * PDFs produced by some MFP firmware (Canon "Adobe PSL", certain Xerox
 * builds, etc.), leaving the user with table grid lines and no text. We
 * sidestep that by rasterizing server-side with poppler — the same path
 * the extraction pipeline uses, which is known to render every PDF we've
 * ingested correctly.
 *
 * Returns:
 * 200 with image/png bytes. Browser-caches for a day.
 *
 * Raises:
 * HTTPException: 403 if order inbox is off, 404 if the order or
 * attachment doesn't exist or isn't a PDF, 422 if the PDF is
 * password-protected, 502 if poppler errored.
 */
export const getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet = <ThrowOnError extends boolean = false>(options: Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData, ThrowOnError>): RequestResult<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetResponses, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetResponses, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/attachments/{attachment_index}/pages/{page}',
    ...options
});

/**
 * Get Order Attachment Xlsx Data
 *
 * Return the parsed sheet contents for an xlsx attachment.
 *
 * Used by the order detail preview to render the workbook as an HTML
 * table — the libreoffice PDF render clips columns past the print page
 * box, which hides part numbers / prices that the LLM actually picked
 * up out of the underlying cells.
 *
 * Returns:
 * XlsxAttachmentData with one entry per visible sheet, each
 * rendered as a padded grid of cell strings.
 *
 * Raises:
 * HTTPException: 403 if order inbox is off, 404 if the order / index
 * is missing or the attachment isn't an xlsx, 422 if the bytes are
 * not a parseable xlsx workbook.
 */
export const getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGet = <ThrowOnError extends boolean = false>(options: Options<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetData, ThrowOnError>): RequestResult<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponses, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponses, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/orders/{order_id}/attachments/{attachment_index}/xlsx-data',
    ...options
});

/**
 * List Products
 *
 * List the current org's product catalog.
 *
 * Returns:
 * The catalog rows (capped at ``limit``) and the total row count.
 *
 * Raises:
 * HTTPException: 403 if the product catalog is not enabled for this
 * org.
 */
export const listProductsAppProductsGet = <ThrowOnError extends boolean = false>(options?: Options<ListProductsAppProductsGetData, ThrowOnError>): RequestResult<ListProductsAppProductsGetResponses, ListProductsAppProductsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListProductsAppProductsGetResponses, ListProductsAppProductsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListProductsAppProductsGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListProductsAppProductsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/products',
    ...options
});

/**
 * Create Product
 *
 * Create a new product in the current org's catalog.
 *
 * Returns:
 * The freshly-created product.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 409 if an existing product in
 * the same org already uses the given SKU.
 */
export const createProductAppProductsPost = <ThrowOnError extends boolean = false>(options: Options<CreateProductAppProductsPostData, ThrowOnError>): RequestResult<CreateProductAppProductsPostResponses, CreateProductAppProductsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateProductAppProductsPostResponses, CreateProductAppProductsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateProductAppProductsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateProductAppProductsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Product
 *
 * Hard-delete a product from the catalog.
 *
 * Soft delete is over-engineering for the trial milestone; a deleted SKU
 * simply stops being matchable against future line items.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org.
 */
export const deleteProductAppProductsProductIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteProductAppProductsProductIdDeleteData, ThrowOnError>): RequestResult<DeleteProductAppProductsProductIdDeleteResponses, DeleteProductAppProductsProductIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProductAppProductsProductIdDeleteResponses, DeleteProductAppProductsProductIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteProductAppProductsProductIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteProductAppProductsProductIdDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/products/{product_id}',
    ...options
});

/**
 * Get Product
 *
 * Return a single product from the current org's catalog.
 *
 * Returns:
 * The product row.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org.
 */
export const getProductAppProductsProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductAppProductsProductIdGetData, ThrowOnError>): RequestResult<GetProductAppProductsProductIdGetResponses, GetProductAppProductsProductIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetProductAppProductsProductIdGetResponses, GetProductAppProductsProductIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetProductAppProductsProductIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetProductAppProductsProductIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/products/{product_id}',
    ...options
});

/**
 * Update Product
 *
 * Apply a partial update to a product.
 *
 * Only fields provided in the request body are modified; the rest are
 * left unchanged.
 *
 * Returns:
 * The updated product row.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org, 409 if changing the SKU would
 * collide with another product in the same org.
 */
export const updateProductAppProductsProductIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateProductAppProductsProductIdPatchData, ThrowOnError>): RequestResult<UpdateProductAppProductsProductIdPatchResponses, UpdateProductAppProductsProductIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProductAppProductsProductIdPatchResponses, UpdateProductAppProductsProductIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateProductAppProductsProductIdPatchBody,
        path: zUpdateProductAppProductsProductIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateProductAppProductsProductIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/products/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tam Reports
 *
 * Get all TAM reports for the current user's organization.
 *
 * Returns reports ordered by creation date (newest first).
 *
 * Returns:
 * List of TAM report summaries.
 */
export const getTamReportsAppTamReportsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTamReportsAppTamReportsGetData, ThrowOnError>): RequestResult<GetTamReportsAppTamReportsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTamReportsAppTamReportsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetTamReportsAppTamReportsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/tam-reports',
    ...options
});

/**
 * Get Tam Report
 *
 * Get a single TAM report by ID (includes full tam_data).
 *
 * Returns:
 * TamReportDetail with all data.
 */
export const getTamReportAppTamReportsReportIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTamReportAppTamReportsReportIdGetData, ThrowOnError>): RequestResult<GetTamReportAppTamReportsReportIdGetResponses, GetTamReportAppTamReportsReportIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetTamReportAppTamReportsReportIdGetResponses, GetTamReportAppTamReportsReportIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetTamReportAppTamReportsReportIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetTamReportAppTamReportsReportIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/tam-reports/{report_id}',
    ...options
});

/**
 * Get Email Preferences
 *
 * Get the current user's email preferences.
 *
 * Returns all configurable (non-ALWAYS_SEND) email types with the user's
 * current enabled/disabled status. Types not explicitly overridden by the
 * user default to enabled.
 *
 * Returns:
 * List of configurable email preferences with metadata.
 */
export const getEmailPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetEmailPreferencesData, ThrowOnError>): RequestResult<GetEmailPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEmailPreferencesResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetEmailPreferencesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/users/me/email-preferences',
    ...options
});

/**
 * Update Email Preferences
 *
 * Update the current user's email preferences.
 *
 * Accepts a list of preferences (email_type + enabled). Only preferences
 * for types currently in the registry are persisted; stale types are
 * silently dropped. After updating, returns the full merged view (same
 * shape as GET).
 *
 * Returns:
 * List of configurable email preferences with updated status.
 */
export const updateEmailPreferences = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailPreferencesData, ThrowOnError>): RequestResult<UpdateEmailPreferencesResponses, UpdateEmailPreferencesErrors, ThrowOnError> => (options.client ?? client).put<UpdateEmailPreferencesResponses, UpdateEmailPreferencesErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateEmailPreferencesBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateEmailPreferencesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/app/users/me/email-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Impersonation Status
 *
 * Get the current impersonation status.
 *
 * Returns:
 * ImpersonationStatus with is_impersonating=True and admin info if in an
 * impersonation session, otherwise is_impersonating=False.
 */
export const getImpersonationStatusSuperuserImpersonationCurrentGet = <ThrowOnError extends boolean = false>(options?: Options<GetImpersonationStatusSuperuserImpersonationCurrentGetData, ThrowOnError>): RequestResult<GetImpersonationStatusSuperuserImpersonationCurrentGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetImpersonationStatusSuperuserImpersonationCurrentGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetImpersonationStatusSuperuserImpersonationCurrentGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/impersonation/current',
    ...options
});

/**
 * Start Impersonation
 *
 * Start an impersonation session for a specific user.
 *
 * Creates a new AccessToken for the target user with impersonation metadata.
 *
 * Returns:
 * Response with Set-Cookie header containing the new impersonation token.
 *
 * Raises:
 * HTTPException: 403 if not superuser, 404 if org/user not found,
 * 400 if already impersonating.
 */
export const startImpersonationSuperuserImpersonationStartPost = <ThrowOnError extends boolean = false>(options: Options<StartImpersonationSuperuserImpersonationStartPostData, ThrowOnError>): RequestResult<StartImpersonationSuperuserImpersonationStartPostResponses, StartImpersonationSuperuserImpersonationStartPostErrors, ThrowOnError> => (options.client ?? client).post<StartImpersonationSuperuserImpersonationStartPostResponses, StartImpersonationSuperuserImpersonationStartPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zStartImpersonationSuperuserImpersonationStartPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/impersonation/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop Impersonation
 *
 * Stop the current impersonation session and restore admin session.
 *
 * Deletes the impersonation token and restores the original admin cookie.
 *
 * Returns:
 * Response with Set-Cookie header containing the original admin token.
 *
 * Raises:
 * HTTPException: 400 if not in impersonation session or admin session expired,
 * 500 if original token not found.
 */
export const stopImpersonationSuperuserImpersonationStopPost = <ThrowOnError extends boolean = false>(options?: Options<StopImpersonationSuperuserImpersonationStopPostData, ThrowOnError>): RequestResult<StopImpersonationSuperuserImpersonationStopPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<StopImpersonationSuperuserImpersonationStopPostResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/impersonation/stop',
    ...options
});

/**
 * List Impersonation Sessions
 *
 * List all active impersonation sessions (superuser only).
 *
 * Returns:
 * ImpersonationSessionList containing all active impersonation sessions.
 *
 * Raises:
 * HTTPException: 403 if user is not a superuser.
 */
export const listImpersonationSessionsSuperuserImpersonationSessionsGet = <ThrowOnError extends boolean = false>(options?: Options<ListImpersonationSessionsSuperuserImpersonationSessionsGetData, ThrowOnError>): RequestResult<ListImpersonationSessionsSuperuserImpersonationSessionsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListImpersonationSessionsSuperuserImpersonationSessionsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListImpersonationSessionsSuperuserImpersonationSessionsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/impersonation/sessions',
    ...options
});

/**
 * Revoke Impersonation Session
 *
 * Force revoke an impersonation session (superuser only).
 *
 * Args:
 * token_prefix: First 8 characters of the token to revoke.
 * user: The authenticated user making the request.
 * session: Database session.
 *
 * Returns:
 * Empty response with 204 status code on success.
 *
 * Raises:
 * HTTPException: 403 if not superuser, 404 if session not found.
 */
export const revokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDelete = <ThrowOnError extends boolean = false>(options: Options<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData, ThrowOnError>): RequestResult<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteResponses, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteResponses, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/impersonation/sessions/{token_prefix}',
    ...options
});

/**
 * Start Backfill Inbox
 *
 * Start a Temporal workflow to backfill COMPANY_EVENT inbox items for an org.
 *
 * Returns:
 * Workflow start metadata and organization info for status polling.
 *
 * Raises:
 * HTTPException: 404 when the organization does not exist, or 503 when
 * Temporal cannot start the workflow.
 */
export const startBackfillInboxSuperuserBackfillInboxPost = <ThrowOnError extends boolean = false>(options: Options<StartBackfillInboxSuperuserBackfillInboxPostData, ThrowOnError>): RequestResult<StartBackfillInboxSuperuserBackfillInboxPostResponses, StartBackfillInboxSuperuserBackfillInboxPostErrors, ThrowOnError> => (options.client ?? client).post<StartBackfillInboxSuperuserBackfillInboxPostResponses, StartBackfillInboxSuperuserBackfillInboxPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zStartBackfillInboxSuperuserBackfillInboxPostQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zStartBackfillInboxSuperuserBackfillInboxPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/backfill-inbox/',
    ...options
});

/**
 * Get Backfill Inbox Status
 *
 * Return the current Temporal status and workflow-reported progress.
 *
 * Returns:
 * Temporal execution status plus workflow progress counters.
 *
 * Raises:
 * HTTPException: 404 when Temporal cannot find the workflow, or 500 when
 * the workflow query returns an unexpected payload.
 */
export const getBackfillInboxStatusSuperuserBackfillInboxStatusGet = <ThrowOnError extends boolean = false>(options: Options<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetData, ThrowOnError>): RequestResult<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponses, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetErrors, ThrowOnError> => (options.client ?? client).get<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponses, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetBackfillInboxStatusSuperuserBackfillInboxStatusGetQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zGetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/backfill-inbox/status',
    ...options
});

/**
 * Parse Validate
 *
 * Parse and validate a CSV/Excel file for superuser bulk upload.
 *
 * Args:
 * session: Database session.
 * current_user: Authenticated superuser issuing the upload.
 * redis: Stores the short-lived validation token required for execute.
 * organization_id: Organization receiving imported accounts.
 * owner_user_id: User who will own created accounts.
 * file: Uploaded CSV or Excel file.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If org/user validation fails or parsing errors.
 */
export const parseValidateSuperuserBatchUploadsParseValidatePost = <ThrowOnError extends boolean = false>(options: Options<ParseValidateSuperuserBatchUploadsParseValidatePostData, ThrowOnError>): RequestResult<ParseValidateSuperuserBatchUploadsParseValidatePostResponses, ParseValidateSuperuserBatchUploadsParseValidatePostErrors, ThrowOnError> => (options.client ?? client).post<ParseValidateSuperuserBatchUploadsParseValidatePostResponses, ParseValidateSuperuserBatchUploadsParseValidatePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zParseValidateSuperuserBatchUploadsParseValidatePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zParseValidateSuperuserBatchUploadsParseValidatePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/batch-uploads/parse-validate',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Execute Batch Upload
 *
 * Execute the superuser batch upload by creating companies and accounts.
 *
 * Creates accounts owned by owner_user_id but records audit trail with the superuser's ID.
 *
 * Args:
 * request: Parsed companies plus validation_token from parse-validate.
 * session: Database session.
 * current_user: Authenticated superuser.
 * temporal: Temporal client for enrichment workflows.
 * redis: Validates the execute token from parse-validate.
 *
 * Returns:
 * ExecuteResponse with stats and created accounts.
 */
export const executeBatchUploadSuperuserBatchUploadsExecutePost = <ThrowOnError extends boolean = false>(options: Options<ExecuteBatchUploadSuperuserBatchUploadsExecutePostData, ThrowOnError>): RequestResult<ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponses, ExecuteBatchUploadSuperuserBatchUploadsExecutePostErrors, ThrowOnError> => (options.client ?? client).post<ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponses, ExecuteBatchUploadSuperuserBatchUploadsExecutePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zExecuteBatchUploadSuperuserBatchUploadsExecutePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zExecuteBatchUploadSuperuserBatchUploadsExecutePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/batch-uploads/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Organization (Admin)
 *
 * Create a new organization with users, buyer profiles, and initial accounts. Requires JWT Bearer authentication and platform administrator privileges. Auth users must be created before calling this endpoint.
 */
export const createOrganizationSuperuserCreatePost = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationSuperuserCreatePostData, ThrowOnError>): RequestResult<CreateOrganizationSuperuserCreatePostResponses, CreateOrganizationSuperuserCreatePostErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationSuperuserCreatePostResponses, CreateOrganizationSuperuserCreatePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateOrganizationSuperuserCreatePostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateOrganizationSuperuserCreatePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/create/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quick Trial Create
 *
 * Create a trial organization from just an email. Parses website, generates prospects, and sets everything up automatically. Requires JWT Bearer authentication and superuser privileges.
 */
export const quickTrialCreateSuperuserCreateQuickPost = <ThrowOnError extends boolean = false>(options: Options<QuickTrialCreateSuperuserCreateQuickPostData, ThrowOnError>): RequestResult<QuickTrialCreateSuperuserCreateQuickPostResponses, QuickTrialCreateSuperuserCreateQuickPostErrors, ThrowOnError> => (options.client ?? client).post<QuickTrialCreateSuperuserCreateQuickPostResponses, QuickTrialCreateSuperuserCreateQuickPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zQuickTrialCreateSuperuserCreateQuickPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQuickTrialCreateSuperuserCreateQuickPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/create/quick',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Enrichment Status
 *
 * Return per-org enrichment status for superuser dashboard.
 *
 * Returns:
 * EnrichmentStatusResponse for superuser enrichment observability.
 */
export const getEnrichmentStatusSuperuserEnrichmentStatusGet = <ThrowOnError extends boolean = false>(options?: Options<GetEnrichmentStatusSuperuserEnrichmentStatusGetData, ThrowOnError>): RequestResult<GetEnrichmentStatusSuperuserEnrichmentStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEnrichmentStatusSuperuserEnrichmentStatusGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetEnrichmentStatusSuperuserEnrichmentStatusGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/enrichment-status/',
    ...options
});

/**
 * Get Enrichment Freshness
 *
 * Return enrichment freshness metrics for superuser dashboard.
 *
 * Returns:
 * FreshnessDashboardResponse for superuser enrichment observability.
 */
export const getEnrichmentFreshnessSuperuserFreshnessGet = <ThrowOnError extends boolean = false>(options?: Options<GetEnrichmentFreshnessSuperuserFreshnessGetData, ThrowOnError>): RequestResult<GetEnrichmentFreshnessSuperuserFreshnessGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEnrichmentFreshnessSuperuserFreshnessGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetEnrichmentFreshnessSuperuserFreshnessGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/freshness/',
    ...options
});

/**
 * Get All Organizations
 *
 * Get all organizations with their users (staff only).
 *
 * Requires SUPPLYCO staff authentication.
 * Returns all organizations and users with service role access.
 *
 * Returns:
 * AdminOrganizationsResponse instance.
 */
export const getAllOrganizationsSuperuserOrganizationsGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllOrganizationsSuperuserOrganizationsGetData, ThrowOnError>): RequestResult<GetAllOrganizationsSuperuserOrganizationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllOrganizationsSuperuserOrganizationsGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAllOrganizationsSuperuserOrganizationsGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/',
    ...options
});

/**
 * Update Organization
 *
 * Update organization settings (staff only).
 *
 * Requires SUPPLYCO staff authentication.
 * Updates organization using service role.
 *
 * Returns:
 * OrganizationInfo instance.
 *
 * Raises:
 * HTTPException: If organization not found
 */
export const updateOrganizationSuperuserOrganizationsOrganizationIdPost = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData, ThrowOnError>): RequestResult<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponses, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostErrors, ThrowOnError> => (options.client ?? client).post<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponses, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostBody,
        path: zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organization Accounts For Admin
 *
 * Get paginated organization accounts for admin account sharing management.
 *
 * This endpoint:
 * - Requires admin role in the organization
 * - Returns paginated accounts in the organization with sharing information
 * - Includes owner, assignee, and sharing status for each account
 * - Supports pagination with pageIndex and pageSize parameters
 *
 * Returns:
 * Page[OrganizationAccountAdmin] instance.
 */
export const getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData, ThrowOnError>): RequestResult<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponses, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponses, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetPath,
        query: zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/accounts/{organization_id}',
    ...options
});

/**
 * Reset User Password
 *
 * Send password reset email to a user (superuser only).
 *
 * Works for any verified user. Triggers the forgot-password flow.
 *
 * Raises:
 * HTTPException: If user not found (404), user not in organization (404),
 * or permission denied (403).
 */
export const resetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData, ThrowOnError>): RequestResult<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponses, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostErrors, ThrowOnError> => (options.client ?? client).post<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponses, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}/users/{user_id}/reset-password',
    ...options
});

/**
 * Disconnect Crm
 *
 * Disconnect an organization's CRM integration (staff only).
 *
 * Sets the active MergeIntegration status to "disconnected".
 * Does not call the Merge API — only updates the local record.
 *
 * Returns:
 * DisconnectCrmResponse with confirmation message.
 *
 * Raises:
 * HTTPException: If no active integration found (404).
 */
export const disconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPost = <ThrowOnError extends boolean = false>(options: Options<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData, ThrowOnError>): RequestResult<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponses, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostErrors, ThrowOnError> => (options.client ?? client).post<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponses, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}/disconnect-crm',
    ...options
});

/**
 * Sync Crm
 *
 * Trigger a CRM sync for an organization (staff only).
 *
 * Starts a Temporal workflow to import CRM data.
 *
 * Returns:
 * SyncCrmResponse with workflow ID and status message.
 *
 * Raises:
 * HTTPException: If no active integration found (404) or sync already running (409).
 */
export const syncCrmSuperuserOrganizationsOrganizationIdSyncCrmPost = <ThrowOnError extends boolean = false>(options: Options<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData, ThrowOnError>): RequestResult<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponses, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostErrors, ThrowOnError> => (options.client ?? client).post<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponses, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}/sync-crm',
    ...options
});

/**
 * Trigger Scout Lead Generation
 *
 * Trigger manual scout lead generation for an organization (staff only).
 *
 * Creates a ScoutRun record and starts the ScoutDiscoveryWorkflow via Temporal.
 *
 * Args:
 * request: Request containing leads_needed parameter
 * organization_id: Organization to generate leads for
 * session: Database session
 * temporal: Temporal client
 *
 * Returns:
 * TriggerScoutLeadGenerationResponse with workflow ID, run ID, and status message.
 *
 * Raises:
 * HTTPException: If organization not found or workflow already running.
 */
export const triggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPost = <ThrowOnError extends boolean = false>(options: Options<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData, ThrowOnError>): RequestResult<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponses, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostErrors, ThrowOnError> => (options.client ?? client).post<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponses, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostBody,
        path: zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}/trigger-scout-lead-generation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rollback Last Scout Claim
 *
 * Re-hide leads from the most recent SCOUT claim for demo prep.
 *
 * This rolls back the customer-facing claim action by setting the claimed
 * accounts back to PRE_GENERATED and reopening the associated inbox item.
 *
 * Returns:
 * Rollback summary.
 *
 * Raises:
 * HTTPException: If no SCOUT claim can be rolled back.
 */
export const rollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPost = <ThrowOnError extends boolean = false>(options: Options<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData, ThrowOnError>): RequestResult<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponses, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostErrors, ThrowOnError> => (options.client ?? client).post<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponses, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/organizations/{organization_id}/rollback-last-scout-claim',
    ...options
});

/**
 * Rerun Triage Analysis
 *
 * Re-run triage analysis (accounts_fit_analysis) for all accounts in an organization.
 *
 * This endpoint is SUPERUSER-ONLY. It:
 * 1. Verifies user is a SUPPLYCO superuser (via require_superuser dependency)
 * 2. Validates that the organization exists
 * 3. Optionally clears existing triage data (with audit logging)
 * 4. Starts AccountEnrichmentWorkflow for each account via Temporal
 *
 * Args:
 * session: SQLAlchemy async session for organization validation.
 * organization_id: ID of the organization to rerun triage for.
 * user: Authenticated superuser (enforced by require_superuser dependency).
 * temporal: Temporal client for starting workflows.
 * clear_triage_data: Whether to clear existing triage data before rerunning.
 *
 * Returns:
 * RerunTriageResponse with workflow start details.
 *
 * Raises:
 * HTTPException: 403 if user is not a superuser (raised by require_superuser dependency),
 * 404 if organization not found, 500 if failed to start workflows.
 */
export const rerunTriageAnalysisSuperuserRerunTriagePost = <ThrowOnError extends boolean = false>(options: Options<RerunTriageAnalysisSuperuserRerunTriagePostData, ThrowOnError>): RequestResult<RerunTriageAnalysisSuperuserRerunTriagePostResponses, RerunTriageAnalysisSuperuserRerunTriagePostErrors, ThrowOnError> => (options.client ?? client).post<RerunTriageAnalysisSuperuserRerunTriagePostResponses, RerunTriageAnalysisSuperuserRerunTriagePostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zRerunTriageAnalysisSuperuserRerunTriagePostQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zRerunTriageAnalysisSuperuserRerunTriagePostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/rerun-triage/',
    ...options
});

/**
 * Generate Tam Report
 *
 * Generate a fresh TAM report for any organization (staff only).
 *
 * Thin wrapper around create_and_dispatch_tam_report. The service handles
 * row creation, workflow dispatch, and FAILED-on-dispatch-error.
 *
 * Returns:
 * GenerateTamReportResponse with the new report id and processing status.
 *
 * Raises:
 * HTTPException: 404 if organization does not exist.
 * RuntimeError: If processing_status is None after creation (should never happen).
 */
export const generateTamReportSuperuserTamReportsPost = <ThrowOnError extends boolean = false>(options: Options<GenerateTamReportSuperuserTamReportsPostData, ThrowOnError>): RequestResult<GenerateTamReportSuperuserTamReportsPostResponses, GenerateTamReportSuperuserTamReportsPostErrors, ThrowOnError> => (options.client ?? client).post<GenerateTamReportSuperuserTamReportsPostResponses, GenerateTamReportSuperuserTamReportsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGenerateTamReportSuperuserTamReportsPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGenerateTamReportSuperuserTamReportsPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/tam-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User
 *
 * Get any user by ID (superuser only).
 *
 * Returns:
 * SuperuserUserResponse with user data.
 *
 * Raises:
 * HTTPException: If user not found (404).
 */
export const getUserSuperuserUsersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUserSuperuserUsersUserIdGetData, ThrowOnError>): RequestResult<GetUserSuperuserUsersUserIdGetResponses, GetUserSuperuserUsersUserIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserSuperuserUsersUserIdGetResponses, GetUserSuperuserUsersUserIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetUserSuperuserUsersUserIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetUserSuperuserUsersUserIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/users/{user_id}',
    ...options
});

/**
 * Update User
 *
 * Update any user (superuser only).
 *
 * Allows updating all user fields including email, verification status,
 * role, and organization.
 *
 * Returns:
 * SuperuserUserResponse with updated user data.
 *
 * Raises:
 * HTTPException: If user not found (404).
 */
export const updateUserSuperuserUsersUserIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateUserSuperuserUsersUserIdPatchData, ThrowOnError>): RequestResult<UpdateUserSuperuserUsersUserIdPatchResponses, UpdateUserSuperuserUsersUserIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserSuperuserUsersUserIdPatchResponses, UpdateUserSuperuserUsersUserIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateUserSuperuserUsersUserIdPatchBody,
        path: zUpdateUserSuperuserUsersUserIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateUserSuperuserUsersUserIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/superuser/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth:Cookie.Login
 */
export const authCookieLoginAuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<AuthCookieLoginAuthLoginPostData, ThrowOnError>): RequestResult<AuthCookieLoginAuthLoginPostResponses, AuthCookieLoginAuthLoginPostErrors, ThrowOnError> => (options.client ?? client).post<AuthCookieLoginAuthLoginPostResponses, AuthCookieLoginAuthLoginPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zAuthCookieLoginAuthLoginPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAuthCookieLoginAuthLoginPostResponse.parseAsync(data),
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Auth:Cookie.Logout
 */
export const authCookieLogoutAuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<AuthCookieLogoutAuthLogoutPostData, ThrowOnError>): RequestResult<AuthCookieLogoutAuthLogoutPostResponses, AuthCookieLogoutAuthLogoutPostErrors, ThrowOnError> => (options?.client ?? client).post<AuthCookieLogoutAuthLogoutPostResponses, AuthCookieLogoutAuthLogoutPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAuthCookieLogoutAuthLogoutPostResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/logout',
    ...options
});

/**
 * Auth:Bearer.Login
 */
export const authBearerLoginAuthBearerLoginPost = <ThrowOnError extends boolean = false>(options: Options<AuthBearerLoginAuthBearerLoginPostData, ThrowOnError>): RequestResult<AuthBearerLoginAuthBearerLoginPostResponses, AuthBearerLoginAuthBearerLoginPostErrors, ThrowOnError> => (options.client ?? client).post<AuthBearerLoginAuthBearerLoginPostResponses, AuthBearerLoginAuthBearerLoginPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zAuthBearerLoginAuthBearerLoginPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAuthBearerLoginAuthBearerLoginPostResponse.parseAsync(data),
    url: '/auth/bearer/login',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Auth:Bearer.Logout
 */
export const authBearerLogoutAuthBearerLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<AuthBearerLogoutAuthBearerLogoutPostData, ThrowOnError>): RequestResult<AuthBearerLogoutAuthBearerLogoutPostResponses, AuthBearerLogoutAuthBearerLogoutPostErrors, ThrowOnError> => (options?.client ?? client).post<AuthBearerLogoutAuthBearerLogoutPostResponses, AuthBearerLogoutAuthBearerLogoutPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/bearer/logout',
    ...options
});

/**
 * Verify:Request-Token
 */
export const verifyRequestTokenAuthRequestVerifyTokenPost = <ThrowOnError extends boolean = false>(options: Options<VerifyRequestTokenAuthRequestVerifyTokenPostData, ThrowOnError>): RequestResult<VerifyRequestTokenAuthRequestVerifyTokenPostResponses, VerifyRequestTokenAuthRequestVerifyTokenPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyRequestTokenAuthRequestVerifyTokenPostResponses, VerifyRequestTokenAuthRequestVerifyTokenPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zVerifyRequestTokenAuthRequestVerifyTokenPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/auth/request-verify-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify:Verify
 */
export const verifyVerifyAuthVerifyPost = <ThrowOnError extends boolean = false>(options: Options<VerifyVerifyAuthVerifyPostData, ThrowOnError>): RequestResult<VerifyVerifyAuthVerifyPostResponses, VerifyVerifyAuthVerifyPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyVerifyAuthVerifyPostResponses, VerifyVerifyAuthVerifyPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zVerifyVerifyAuthVerifyPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zVerifyVerifyAuthVerifyPostResponse.parseAsync(data),
    url: '/auth/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset:Forgot Password
 */
export const resetForgotPasswordAuthForgotPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ResetForgotPasswordAuthForgotPasswordPostData, ThrowOnError>): RequestResult<ResetForgotPasswordAuthForgotPasswordPostResponses, ResetForgotPasswordAuthForgotPasswordPostErrors, ThrowOnError> => (options.client ?? client).post<ResetForgotPasswordAuthForgotPasswordPostResponses, ResetForgotPasswordAuthForgotPasswordPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zResetForgotPasswordAuthForgotPasswordPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset:Reset Password
 */
export const resetResetPasswordAuthResetPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ResetResetPasswordAuthResetPasswordPostData, ThrowOnError>): RequestResult<ResetResetPasswordAuthResetPasswordPostResponses, ResetResetPasswordAuthResetPasswordPostErrors, ThrowOnError> => (options.client ?? client).post<ResetResetPasswordAuthResetPasswordPostResponses, ResetResetPasswordAuthResetPasswordPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zResetResetPasswordAuthResetPasswordPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users:Current User
 */
export const usersCurrentUserAuthUsersMeGet = <ThrowOnError extends boolean = false>(options?: Options<UsersCurrentUserAuthUsersMeGetData, ThrowOnError>): RequestResult<UsersCurrentUserAuthUsersMeGetResponses, UsersCurrentUserAuthUsersMeGetErrors, ThrowOnError> => (options?.client ?? client).get<UsersCurrentUserAuthUsersMeGetResponses, UsersCurrentUserAuthUsersMeGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUsersCurrentUserAuthUsersMeGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/users/me',
    ...options
});

/**
 * Users:Patch Current User
 */
export const usersPatchCurrentUserAuthUsersMePatch = <ThrowOnError extends boolean = false>(options: Options<UsersPatchCurrentUserAuthUsersMePatchData, ThrowOnError>): RequestResult<UsersPatchCurrentUserAuthUsersMePatchResponses, UsersPatchCurrentUserAuthUsersMePatchErrors, ThrowOnError> => (options.client ?? client).patch<UsersPatchCurrentUserAuthUsersMePatchResponses, UsersPatchCurrentUserAuthUsersMePatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUsersPatchCurrentUserAuthUsersMePatchBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUsersPatchCurrentUserAuthUsersMePatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users:Delete User
 */
export const usersDeleteUserAuthUsersIdDelete = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteUserAuthUsersIdDeleteData, ThrowOnError>): RequestResult<UsersDeleteUserAuthUsersIdDeleteResponses, UsersDeleteUserAuthUsersIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UsersDeleteUserAuthUsersIdDeleteResponses, UsersDeleteUserAuthUsersIdDeleteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zUsersDeleteUserAuthUsersIdDeletePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUsersDeleteUserAuthUsersIdDeleteResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/users/{id}',
    ...options
});

/**
 * Users:User
 */
export const usersUserAuthUsersIdGet = <ThrowOnError extends boolean = false>(options: Options<UsersUserAuthUsersIdGetData, ThrowOnError>): RequestResult<UsersUserAuthUsersIdGetResponses, UsersUserAuthUsersIdGetErrors, ThrowOnError> => (options.client ?? client).get<UsersUserAuthUsersIdGetResponses, UsersUserAuthUsersIdGetErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zUsersUserAuthUsersIdGetPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUsersUserAuthUsersIdGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/users/{id}',
    ...options
});

/**
 * Users:Patch User
 */
export const usersPatchUserAuthUsersIdPatch = <ThrowOnError extends boolean = false>(options: Options<UsersPatchUserAuthUsersIdPatchData, ThrowOnError>): RequestResult<UsersPatchUserAuthUsersIdPatchResponses, UsersPatchUserAuthUsersIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UsersPatchUserAuthUsersIdPatchResponses, UsersPatchUserAuthUsersIdPatchErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUsersPatchUserAuthUsersIdPatchBody,
        path: zUsersPatchUserAuthUsersIdPatchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUsersPatchUserAuthUsersIdPatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Magic Link
 *
 * Send a magic link to the user's email.
 *
 * Args:
 * email: The email to send the magic link to.
 * email_service: The email service.
 * secret_key: The secret key to use for generating the token.
 *
 * Raises:
 * HTTPException: If the email fails to send.
 */
export const magicLinkAuthMagicLinkPost = <ThrowOnError extends boolean = false>(options: Options<MagicLinkAuthMagicLinkPostData, ThrowOnError>): RequestResult<MagicLinkAuthMagicLinkPostResponses, MagicLinkAuthMagicLinkPostErrors, ThrowOnError> => (options.client ?? client).post<MagicLinkAuthMagicLinkPostResponses, MagicLinkAuthMagicLinkPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zMagicLinkAuthMagicLinkPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/auth/magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Magic Link Callback
 *
 * Verify a magic link.
 *
 * Be careful touching this, it's a hack around fastapi_users's verification process.
 *
 * Args:
 * token: The token to verify the magic link.
 * user_manager: The user manager.
 * strategy: The strategy to use for authentication.
 * secret_key: The secret key to use for decoding the token.
 * redis: Async Redis client for single-use token enforcement.
 * posthog: Server-side analytics client.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If the token is invalid.
 */
export const magicLinkCallbackAuthMagicLinkCallbackPost = <ThrowOnError extends boolean = false>(options: Options<MagicLinkCallbackAuthMagicLinkCallbackPostData, ThrowOnError>): RequestResult<MagicLinkCallbackAuthMagicLinkCallbackPostResponses, MagicLinkCallbackAuthMagicLinkCallbackPostErrors, ThrowOnError> => (options.client ?? client).post<MagicLinkCallbackAuthMagicLinkCallbackPostResponses, MagicLinkCallbackAuthMagicLinkCallbackPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    requestValidator: async (data) => await z.object({
        body: zMagicLinkCallbackAuthMagicLinkCallbackPostBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/auth/magic-link/callback',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Get Superuser Impersonation Status
 *
 * Check if the current session is a superuser impersonation session.
 *
 * This endpoint is accessible to all authenticated users so that impersonated
 * users can see their impersonation status and the impersonation banner.
 *
 * Returns:
 * SuperuserImpersonationStatus with is_impersonating=True and admin info
 * if in an impersonation session, otherwise is_impersonating=False.
 */
export const getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGet = <ThrowOnError extends boolean = false>(options?: Options<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetData, ThrowOnError>): RequestResult<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: 'fastapiusersauth',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/auth/superuser-impersonation-status',
    ...options
});

/**
 * Inbound Email
 *
 * Receive an inbound email webhook from Resend.
 *
 * Returns:
 * ``{"ok": True}`` on happy path.
 * ``{"ok": True, "skipped": "unsupported_event_type"}`` if Resend
 * delivers an event other than :data:`SUPPORTED_EVENT_TYPE` to
 * this URL — a 200 keeps Resend's retry queue from filling up
 * with events we'll never act on.
 * ``{"ok": True, "skipped": "wrong_domain"|"unknown_recipient"|"blocked"}``
 * when the request was bounced at receipt without dispatching the
 * extraction workflow.
 * ``{"ok": True, "duplicate": True}`` if the message_id was already
 * ingested (idempotent no-op).
 */
export const inboundEmailWebhooksInboundEmailPost = <ThrowOnError extends boolean = false>(options?: Options<InboundEmailWebhooksInboundEmailPostData, ThrowOnError>): RequestResult<InboundEmailWebhooksInboundEmailPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<InboundEmailWebhooksInboundEmailPostResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zInboundEmailWebhooksInboundEmailPostResponse.parseAsync(data),
    url: '/webhooks/inbound-email',
    ...options
});

/**
 * Mailpit Inbound
 *
 * Receive an inbound email webhook from Mailpit.
 *
 * Returns:
 * ``{"ok": True}`` on happy-path.
 * ``{"ok": True, "skipped": "<reason>"}`` when the message is not
 * addressed to the inbound inbox (or has no id). Always 200 so
 * Mailpit doesn't retry noisy cases.
 *
 * Raises:
 * HTTPException: 502 if the Mailpit API is unreachable or returns an
 * error fetching the full message.
 */
export const mailpitInboundWebhooksMailpitInboundPost = <ThrowOnError extends boolean = false>(options?: Options<MailpitInboundWebhooksMailpitInboundPostData, ThrowOnError>): RequestResult<MailpitInboundWebhooksMailpitInboundPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MailpitInboundWebhooksMailpitInboundPostResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMailpitInboundWebhooksMailpitInboundPostResponse.parseAsync(data),
    url: '/webhooks/mailpit-inbound',
    ...options
});

/**
 * List Dev Users
 *
 * List all users available for dev login.
 *
 * Returns all users in the database, useful for the dev user switcher UI.
 *
 * Returns:
 * DevUsersResponse with list of all users.
 */
export const listDevUsersDevUsersGet = <ThrowOnError extends boolean = false>(options?: Options<ListDevUsersDevUsersGetData, ThrowOnError>): RequestResult<ListDevUsersDevUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDevUsersDevUsersGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListDevUsersDevUsersGetResponse.parseAsync(data),
    url: '/dev/users',
    ...options
});

/**
 * Dev Login
 *
 * Login as any user by email without password.
 *
 * DEV ONLY - bypasses password verification for rapid user switching.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: 404 if user not found.
 */
export const devLoginDevLoginEmailPost = <ThrowOnError extends boolean = false>(options: Options<DevLoginDevLoginEmailPostData, ThrowOnError>): RequestResult<DevLoginDevLoginEmailPostResponses, DevLoginDevLoginEmailPostErrors, ThrowOnError> => (options.client ?? client).post<DevLoginDevLoginEmailPostResponses, DevLoginDevLoginEmailPostErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDevLoginDevLoginEmailPostPath,
        query: z.never().optional()
    }).parseAsync(data),
    url: '/dev/login/{email}',
    ...options
});

/**
 * Health Check
 *
 * Check the health of the application.
 *
 * Returns:
 * dict[str, Any] instance.
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zHealthCheckHealthGetResponse.parseAsync(data),
    url: '/health',
    ...options
});

/**
 * Health Detailed
 *
 * Detailed health check with memory and process diagnostics.
 *
 * Returns:
 * Health status with memory usage, PID, uptime, and background task count.
 */
export const healthDetailedHealthDetailedGet = <ThrowOnError extends boolean = false>(options?: Options<HealthDetailedHealthDetailedGetData, ThrowOnError>): RequestResult<HealthDetailedHealthDetailedGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthDetailedHealthDetailedGetResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zHealthDetailedHealthDetailedGetResponse.parseAsync(data),
    url: '/health/detailed',
    ...options
});
